import * as i1$1 from '@angular/common';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule, EventEmitter, inject, Component, Input, Output, Pipe, Injectable, input, computed, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, Directive, ViewChild, ViewChildren, EnvironmentInjector } from '@angular/core';
import * as i3 from '@skyux/icon';
import { SkyIconModule } from '@skyux/icon';
export { SkyIconModule, λ1 as λ4, λ2 as λ5 } from '@skyux/icon';
import * as i1 from '@skyux/theme';
import { SkyThemeComponentClassDirective, SkyThemeModule } from '@skyux/theme';
import * as i4 from '@skyux/i18n';
import { SkyLibResourcesService, getLibStringForLocale, SkyI18nModule, SKY_LIB_RESOURCES_PROVIDERS } from '@skyux/i18n';
import * as i3$1 from '@skyux/core';
import { SkyLogService, SkyTrimModule, SkyIdModule, SkyMutationObserverService, SkyLiveAnnouncerService, SkyScreenReaderLabelDirective, SkyAppWindowRef, SkyDynamicComponentService } from '@skyux/core';
import { toSignal, toObservable } from '@angular/core/rxjs-interop';
import { switchMap, from, of, catchError, take, Subject, BehaviorSubject, defer } from 'rxjs';
import * as i2 from '@skyux/help-inline';
import { SkyHelpInlineModule as SkyHelpInlineModule$1 } from '@skyux/help-inline';
import { trigger, transition, style, animate } from '@angular/animations';
import { takeUntil, take as take$1, finalize } from 'rxjs/operators';

/* istanbul ignore file */
/**
 * NOTICE: DO NOT MODIFY THIS FILE!
 * The contents of this file were automatically generated by
 * the 'ng generate @skyux/i18n:lib-resources-module lib/modules/shared/sky-indicators' schematic.
 * To update this file, simply rerun the command.
 */
const RESOURCES = {
    'EN-US': {
        skyux_alert_close: { message: 'Close the alert' },
        skyux_alert_sr_attention: { message: 'Attention:' },
        skyux_alert_sr_caution: { message: 'Caution:' },
        skyux_alert_sr_completed: { message: 'Completed:' },
        skyux_alert_sr_danger: { message: 'Danger:' },
        skyux_alert_sr_error: { message: 'Error:' },
        skyux_alert_sr_important_info: { message: 'Important information:' },
        skyux_alert_sr_important_warning: { message: 'Important warning:' },
        skyux_alert_sr_success: { message: 'Success:' },
        skyux_alert_sr_warning: { message: 'Warning:' },
        skyux_help_inline_button_title: { message: 'Show help content' },
        skyux_label_sr_attention: { message: 'Attention:' },
        skyux_label_sr_caution: { message: 'Caution:' },
        skyux_label_sr_completed: { message: 'Completed:' },
        skyux_label_sr_danger: { message: 'Danger:' },
        skyux_label_sr_error: { message: 'Error:' },
        skyux_label_sr_important_info: { message: 'Important information:' },
        skyux_label_sr_important_warning: { message: 'Important warning:' },
        skyux_label_sr_success: { message: 'Success:' },
        skyux_label_sr_warning: { message: 'Warning:' },
        skyux_status_indicator_sr_attention: { message: 'Attention:' },
        skyux_status_indicator_sr_caution: { message: 'Caution:' },
        skyux_status_indicator_sr_completed: { message: 'Completed:' },
        skyux_status_indicator_sr_danger: { message: 'Danger:' },
        skyux_status_indicator_sr_error: { message: 'Error:' },
        skyux_status_indicator_sr_important_info: {
            message: 'Important information:',
        },
        skyux_status_indicator_sr_important_warning: {
            message: 'Important warning:',
        },
        skyux_status_indicator_sr_success: { message: 'Success:' },
        skyux_status_indicator_sr_warning: { message: 'Warning:' },
        skyux_tokens_dismiss_button_default_label: { message: 'Remove ' },
        skyux_tokens_dismiss_button_title: { message: 'Remove item' },
        skyux_tokens_token_dismissed: { message: '{0} removed' },
        skyux_wait_aria_alt_text: { message: 'Loading.' },
        skyux_wait_blocking_aria_alt_text: { message: 'Loading. Please wait.' },
        skyux_wait_page_aria_alt_text: { message: 'Page loading.' },
        skyux_wait_page_blocking_aria_alt_text: {
            message: 'Page loading. Please wait.',
        },
        skyux_wait_screen_reader_completed_text: { message: 'Loading complete.' },
        skyux_wait_page_screen_reader_completed_text: {
            message: 'Page loading complete.',
        },
    },
};
SkyLibResourcesService.addResources(RESOURCES);
class SkyIndicatorsResourcesProvider {
    getString(localeInfo, name) {
        return getLibStringForLocale(RESOURCES, localeInfo.locale, name);
    }
}
/**
 * Import into any component library module that needs to use resource strings.
 */
class SkyIndicatorsResourcesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIndicatorsResourcesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyIndicatorsResourcesModule, exports: [SkyI18nModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIndicatorsResourcesModule, providers: [
            {
                provide: SKY_LIB_RESOURCES_PROVIDERS,
                useClass: SkyIndicatorsResourcesProvider,
                multi: true,
            },
        ], imports: [SkyI18nModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIndicatorsResourcesModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [SkyI18nModule],
                    providers: [
                        {
                            provide: SKY_LIB_RESOURCES_PROVIDERS,
                            useClass: SkyIndicatorsResourcesProvider,
                            multi: true,
                        },
                    ],
                }]
        }] });

/**
 * @internal
 */
class SkyIndicatorIconUtility {
    static getIconsForType(indicatorType) {
        let icon;
        let baseIcon;
        let topIcon;
        switch (indicatorType) {
            case 'danger':
            case 'warning':
                icon = 'warning';
                baseIcon = 'triangle-solid';
                topIcon = 'exclamation';
                break;
            case 'info':
                icon = 'exclamation-circle';
                baseIcon = 'circle-solid';
                topIcon = 'help-i';
                break;
            case 'success':
                icon = 'check';
                baseIcon = 'circle-solid';
                topIcon = 'check';
                break;
        }
        return {
            defaultThemeIcon: icon,
            modernThemeBaseIcon: {
                icon: baseIcon,
                iconType: 'skyux',
            },
            modernThemeTopIcon: {
                icon: topIcon,
                iconType: 'skyux',
            },
        };
    }
}

const ALERT_TYPE_DEFAULT = 'warning';
class SkyAlertComponent {
    constructor() {
        /**
         * Fires when users close the alert.
         */
        this.closedChange = new EventEmitter();
        this.alertTypeOrDefault = ALERT_TYPE_DEFAULT;
        this.#resources = inject(SkyLibResourcesService);
        this.#logSvc = inject(SkyLogService);
    }
    /**
     * The style for the alert, which determines the icon and background color.
     * The valid options are `danger`, `info`, `success`, and `warning`.
     * @default "warning"
     */
    set alertType(value) {
        if (value !== this.alertTypeOrDefault) {
            this.alertTypeOrDefault = value || ALERT_TYPE_DEFAULT;
            this.#updateAlertIcon();
        }
    }
    /**
     * The predefined text to be read by screen readers for users who cannot see the alert icon.
     * This property is optional but will be required in future versions of SKY UX.
     */
    set descriptionType(value) {
        this.#_descriptionType = value;
        this.#updateDescriptionComputed();
    }
    get descriptionType() {
        return this.#_descriptionType;
    }
    /**
     * The text to be read by screen readers for users who cannot see
     * the indicator icon when `descriptionType` is `custom`.
     */
    set customDescription(value) {
        this.#_customDescription = value;
        this.#updateDescriptionComputed();
    }
    get customDescription() {
        return this.#_customDescription;
    }
    #_descriptionType;
    #_customDescription;
    #descriptionTypeResourceSubscription;
    #descriptionTypeWarned;
    #resources;
    #logSvc;
    ngOnInit() {
        this.#updateAlertIcon();
    }
    ngAfterViewChecked() {
        if (!this.descriptionType && !this.#descriptionTypeWarned) {
            this.#logSvc.deprecated('SkyAlertComponent without `descriptionType`', {
                deprecationMajorVersion: 8,
                replacementRecommendation: 'Always specify a `descriptionType` property.',
            });
            this.#descriptionTypeWarned = true;
        }
    }
    ngOnDestroy() {
        this.#unsubscribe();
    }
    close() {
        this.closed = true;
        this.closedChange.emit(true);
    }
    #updateAlertIcon() {
        const indicatorIcon = SkyIndicatorIconUtility.getIconsForType(this.alertTypeOrDefault);
        this.alertBaseIcon = indicatorIcon.modernThemeBaseIcon;
        this.alertTopIcon = indicatorIcon.modernThemeTopIcon;
    }
    #updateDescriptionComputed() {
        this.#unsubscribe();
        if (this.descriptionType) {
            switch (this.descriptionType) {
                case 'none':
                    this.descriptionComputed = undefined;
                    break;
                case 'custom':
                    this.descriptionComputed = this.customDescription;
                    break;
                default:
                    this.#descriptionTypeResourceSubscription = this.#resources
                        .getString('skyux_alert_sr_' + this.descriptionType.replace(/-/g, '_'))
                        .subscribe((value) => {
                        this.descriptionComputed = value;
                    });
                    break;
            }
        }
        else {
            this.descriptionComputed = undefined;
        }
    }
    #unsubscribe() {
        if (this.#descriptionTypeResourceSubscription) {
            this.#descriptionTypeResourceSubscription.unsubscribe();
            this.#descriptionTypeResourceSubscription = undefined;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyAlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyAlertComponent, selector: "sky-alert", inputs: { alertType: "alertType", closeable: "closeable", closed: "closed", descriptionType: "descriptionType", customDescription: "customDescription" }, outputs: { closedChange: "closedChange" }, hostDirectives: [{ directive: i1.SkyThemeComponentClassDirective }], ngImport: i0, template: "<div\n  class=\"sky-alert\"\n  [skyThemeClass]=\"{\n    'sky-rounded-corners': 'default',\n    'sky-box sky-elevation-1': 'modern'\n  }\"\n  role=\"alert\"\n  [hidden]=\"closed\"\n  [ngClass]=\"{\n    'sky-alert-info': alertTypeOrDefault === 'info',\n    'sky-alert-success': alertTypeOrDefault === 'success',\n    'sky-alert-warning': alertTypeOrDefault === 'warning',\n    'sky-alert-danger': alertTypeOrDefault === 'danger',\n    'sky-alert-closeable': closeable\n  }\"\n>\n  <div aria-hidden=\"true\" class=\"sky-alert-icon-theme-modern\">\n    <sky-icon-stack [baseIcon]=\"alertBaseIcon\" [topIcon]=\"alertTopIcon\">\n    </sky-icon-stack>\n  </div>\n  <span *ngIf=\"descriptionComputed\" class=\"sky-screen-reader-only\">\n    {{ descriptionComputed }}\n  </span>\n  <div class=\"sky-alert-content\">\n    <ng-content />\n  </div>\n  <button\n    class=\"sky-alert-close\"\n    type=\"button\"\n    [attr.aria-label]=\"'skyux_alert_close' | skyLibResources\"\n    [hidden]=\"!closeable\"\n    (click)=\"close()\"\n  >\n    <span aria-hidden=\"true\">\n      <sky-icon icon=\"close\" />\n    </span>\n  </button>\n</div>\n", styles: [":host.sky-cmp-theme-default{display:block}.sky-alert:not(.sky-theme-modern *){padding:0 10px;border-left:solid 30px;color:var(--sky-text-color-default);display:flex;flex-direction:row;align-items:center}.sky-alert:not(.sky-theme-modern *) .sky-alert-content{padding:10px 0;width:100%}.sky-alert:not(.sky-theme-modern *) .sky-alert-content ::ng-deep a{color:#212327cc;text-decoration:underline}.sky-alert:not(.sky-theme-modern *) .sky-alert-content ::ng-deep a:hover{color:var(--sky-text-color-default)}.sky-alert:not(.sky-theme-modern *) button{margin-left:auto;width:32px;height:32px}.sky-alert:not(.sky-theme-modern *).sky-alert-info:before,.sky-alert:not(.sky-theme-modern *).sky-alert-success:before,.sky-alert:not(.sky-theme-modern *).sky-alert-warning:before,.sky-alert:not(.sky-theme-modern *).sky-alert-danger:before{font-family:FontAwesome;margin-left:-32px;margin-right:19px;color:#fff}.sky-alert:not(.sky-theme-modern *):not(.sky-alert-danger){--sky-icon-stack-top-icon-color-override: #212327}.sky-alert:not(.sky-theme-modern *).sky-alert-info{background-color:var(--sky-background-color-info);border-color:var(--sky-highlight-color-info)}.sky-alert:not(.sky-theme-modern *).sky-alert-info:before{content:\"\\f06a\";margin-left:-31px;margin-right:20px}.sky-alert:not(.sky-theme-modern *).sky-alert-success{background-color:var(--sky-background-color-success);border-color:var(--sky-highlight-color-success)}.sky-alert:not(.sky-theme-modern *).sky-alert-success:before{content:\"\\f00c\"}.sky-alert:not(.sky-theme-modern *).sky-alert-warning{background-color:var(--sky-background-color-warning);border-color:var(--sky-highlight-color-warning)}.sky-alert:not(.sky-theme-modern *).sky-alert-warning:before{content:\"\\f071\"}.sky-alert:not(.sky-theme-modern *).sky-alert-danger{background-color:var(--sky-background-color-danger);border-color:var(--sky-highlight-color-danger)}.sky-alert:not(.sky-theme-modern *).sky-alert-danger:before{content:\"\\f071\"}.sky-alert:not(.sky-theme-modern *) .sky-alert-close{cursor:pointer;font-weight:700;line-height:1;margin:0;padding:0;color:var(--sky-text-color-default);opacity:.8;border:none;border-radius:3px;background-color:transparent;display:none;flex-shrink:0}.sky-alert:not(.sky-theme-modern *) .sky-alert-close:hover{opacity:1;border:none}.sky-alert:not(.sky-theme-modern *) .sky-alert-close:focus-visible{border:var(--sky-background-color-primary-dark) solid 2px;outline:none}.sky-alert:not(.sky-theme-modern *) .sky-alert-close:active{border:none}.sky-alert:not(.sky-theme-modern *) .sky-alert-close:focus-visible:not(:active){box-shadow:none}.sky-alert:not(.sky-theme-modern *).sky-alert-closeable .sky-alert-close{display:block}.sky-alert:not(.sky-theme-modern *) .sky-alert-icon-theme-modern{display:none}\n", ":host-context(.sky-theme-modern) :host.sky-cmp-theme-modern{display:block}:is(.sky-theme-modern .sky-alert){padding:0 10px;border-left:solid 7px;color:var(--sky-text-color-default);display:flex;flex-direction:row;align-items:center}:is(.sky-theme-modern .sky-alert) .sky-alert-content{padding:var(--sky-padding-even-md);width:100%}:is(.sky-theme-modern .sky-alert) .sky-alert-content ::ng-deep a{color:#212327cc;text-decoration:underline}:is(.sky-theme-modern .sky-alert) .sky-alert-content ::ng-deep a:hover{color:var(--sky-text-color-default)}:is(.sky-theme-modern .sky-alert) button{margin-left:auto;width:32px;height:32px}:is(.sky-theme-modern .sky-alert).sky-alert-info:before,:is(.sky-theme-modern .sky-alert).sky-alert-success:before,:is(.sky-theme-modern .sky-alert).sky-alert-warning:before,:is(.sky-theme-modern .sky-alert).sky-alert-danger:before{display:none}:is(.sky-theme-modern .sky-alert):not(.sky-alert-danger){--sky-icon-stack-top-icon-color-override: #212327}:is(.sky-theme-modern .sky-alert).sky-alert-info{background-color:var(--sky-background-color-info-light);border-color:var(--sky-highlight-color-info)}:is(.sky-theme-modern .sky-alert).sky-alert-info:before{content:\"\\f06a\";margin-left:-31px;margin-right:20px}:is(.sky-theme-modern .sky-alert).sky-alert-success{background-color:var(--sky-background-color-success);border-color:var(--sky-highlight-color-success)}:is(.sky-theme-modern .sky-alert).sky-alert-success:before{content:\"\\f00c\"}:is(.sky-theme-modern .sky-alert).sky-alert-warning{background-color:var(--sky-background-color-warning);border-color:var(--sky-highlight-color-warning)}:is(.sky-theme-modern .sky-alert).sky-alert-warning:before{content:\"\\f071\"}:is(.sky-theme-modern .sky-alert).sky-alert-danger{background-color:var(--sky-background-color-danger);border-color:var(--sky-highlight-color-danger)}:is(.sky-theme-modern .sky-alert).sky-alert-danger:before{content:\"\\f071\"}:is(.sky-theme-modern .sky-alert) .sky-alert-close{cursor:pointer;font-weight:700;line-height:1;margin:0;padding:0;color:var(--sky-text-color-default);border:none;border-radius:6px;background-color:transparent;display:none;flex-shrink:0}:is(.sky-theme-modern .sky-alert) .sky-alert-close:hover{opacity:1;border:var(--sky-background-color-primary-dark) solid 1px}:is(.sky-theme-modern .sky-alert) .sky-alert-close:focus-visible{border:var(--sky-background-color-primary-dark) solid 2px;outline:none}:is(.sky-theme-modern .sky-alert) .sky-alert-close:active{border:var(--sky-background-color-primary-dark) solid 2px}:is(.sky-theme-modern .sky-alert) .sky-alert-close:focus-visible:not(:active){box-shadow:0 1px 3px #0000004d}:is(.sky-theme-modern .sky-alert).sky-alert-closeable .sky-alert-close{display:block}:is(.sky-theme-modern .sky-alert) .sky-alert-icon-theme-modern{display:block}:is(.sky-theme-modern .sky-alert).sky-alert-info .sky-alert-icon-theme-modern{color:var(--sky-highlight-color-info)}:is(.sky-theme-modern .sky-alert).sky-alert-success .sky-alert-icon-theme-modern{color:var(--sky-highlight-color-success)}:is(.sky-theme-modern .sky-alert).sky-alert-warning .sky-alert-icon-theme-modern{color:var(--sky-highlight-color-warning)}:is(.sky-theme-modern .sky-alert).sky-alert-danger .sky-alert-icon-theme-modern{color:var(--sky-highlight-color-danger)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.λ1, selector: "sky-icon", inputs: ["icon", "iconName", "iconType", "size", "fixedWidth", "variant"] }, { kind: "component", type: i3.λ2, selector: "sky-icon-stack", inputs: ["size", "baseIcon", "topIcon"] }, { kind: "directive", type: i1.λ2, selector: "[skyThemeClass]", inputs: ["class", "skyThemeClass"] }, { kind: "pipe", type: i4.SkyLibResourcesPipe, name: "skyLibResources" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-alert', hostDirectives: [SkyThemeComponentClassDirective], template: "<div\n  class=\"sky-alert\"\n  [skyThemeClass]=\"{\n    'sky-rounded-corners': 'default',\n    'sky-box sky-elevation-1': 'modern'\n  }\"\n  role=\"alert\"\n  [hidden]=\"closed\"\n  [ngClass]=\"{\n    'sky-alert-info': alertTypeOrDefault === 'info',\n    'sky-alert-success': alertTypeOrDefault === 'success',\n    'sky-alert-warning': alertTypeOrDefault === 'warning',\n    'sky-alert-danger': alertTypeOrDefault === 'danger',\n    'sky-alert-closeable': closeable\n  }\"\n>\n  <div aria-hidden=\"true\" class=\"sky-alert-icon-theme-modern\">\n    <sky-icon-stack [baseIcon]=\"alertBaseIcon\" [topIcon]=\"alertTopIcon\">\n    </sky-icon-stack>\n  </div>\n  <span *ngIf=\"descriptionComputed\" class=\"sky-screen-reader-only\">\n    {{ descriptionComputed }}\n  </span>\n  <div class=\"sky-alert-content\">\n    <ng-content />\n  </div>\n  <button\n    class=\"sky-alert-close\"\n    type=\"button\"\n    [attr.aria-label]=\"'skyux_alert_close' | skyLibResources\"\n    [hidden]=\"!closeable\"\n    (click)=\"close()\"\n  >\n    <span aria-hidden=\"true\">\n      <sky-icon icon=\"close\" />\n    </span>\n  </button>\n</div>\n", styles: [":host.sky-cmp-theme-default{display:block}.sky-alert:not(.sky-theme-modern *){padding:0 10px;border-left:solid 30px;color:var(--sky-text-color-default);display:flex;flex-direction:row;align-items:center}.sky-alert:not(.sky-theme-modern *) .sky-alert-content{padding:10px 0;width:100%}.sky-alert:not(.sky-theme-modern *) .sky-alert-content ::ng-deep a{color:#212327cc;text-decoration:underline}.sky-alert:not(.sky-theme-modern *) .sky-alert-content ::ng-deep a:hover{color:var(--sky-text-color-default)}.sky-alert:not(.sky-theme-modern *) button{margin-left:auto;width:32px;height:32px}.sky-alert:not(.sky-theme-modern *).sky-alert-info:before,.sky-alert:not(.sky-theme-modern *).sky-alert-success:before,.sky-alert:not(.sky-theme-modern *).sky-alert-warning:before,.sky-alert:not(.sky-theme-modern *).sky-alert-danger:before{font-family:FontAwesome;margin-left:-32px;margin-right:19px;color:#fff}.sky-alert:not(.sky-theme-modern *):not(.sky-alert-danger){--sky-icon-stack-top-icon-color-override: #212327}.sky-alert:not(.sky-theme-modern *).sky-alert-info{background-color:var(--sky-background-color-info);border-color:var(--sky-highlight-color-info)}.sky-alert:not(.sky-theme-modern *).sky-alert-info:before{content:\"\\f06a\";margin-left:-31px;margin-right:20px}.sky-alert:not(.sky-theme-modern *).sky-alert-success{background-color:var(--sky-background-color-success);border-color:var(--sky-highlight-color-success)}.sky-alert:not(.sky-theme-modern *).sky-alert-success:before{content:\"\\f00c\"}.sky-alert:not(.sky-theme-modern *).sky-alert-warning{background-color:var(--sky-background-color-warning);border-color:var(--sky-highlight-color-warning)}.sky-alert:not(.sky-theme-modern *).sky-alert-warning:before{content:\"\\f071\"}.sky-alert:not(.sky-theme-modern *).sky-alert-danger{background-color:var(--sky-background-color-danger);border-color:var(--sky-highlight-color-danger)}.sky-alert:not(.sky-theme-modern *).sky-alert-danger:before{content:\"\\f071\"}.sky-alert:not(.sky-theme-modern *) .sky-alert-close{cursor:pointer;font-weight:700;line-height:1;margin:0;padding:0;color:var(--sky-text-color-default);opacity:.8;border:none;border-radius:3px;background-color:transparent;display:none;flex-shrink:0}.sky-alert:not(.sky-theme-modern *) .sky-alert-close:hover{opacity:1;border:none}.sky-alert:not(.sky-theme-modern *) .sky-alert-close:focus-visible{border:var(--sky-background-color-primary-dark) solid 2px;outline:none}.sky-alert:not(.sky-theme-modern *) .sky-alert-close:active{border:none}.sky-alert:not(.sky-theme-modern *) .sky-alert-close:focus-visible:not(:active){box-shadow:none}.sky-alert:not(.sky-theme-modern *).sky-alert-closeable .sky-alert-close{display:block}.sky-alert:not(.sky-theme-modern *) .sky-alert-icon-theme-modern{display:none}\n", ":host-context(.sky-theme-modern) :host.sky-cmp-theme-modern{display:block}:is(.sky-theme-modern .sky-alert){padding:0 10px;border-left:solid 7px;color:var(--sky-text-color-default);display:flex;flex-direction:row;align-items:center}:is(.sky-theme-modern .sky-alert) .sky-alert-content{padding:var(--sky-padding-even-md);width:100%}:is(.sky-theme-modern .sky-alert) .sky-alert-content ::ng-deep a{color:#212327cc;text-decoration:underline}:is(.sky-theme-modern .sky-alert) .sky-alert-content ::ng-deep a:hover{color:var(--sky-text-color-default)}:is(.sky-theme-modern .sky-alert) button{margin-left:auto;width:32px;height:32px}:is(.sky-theme-modern .sky-alert).sky-alert-info:before,:is(.sky-theme-modern .sky-alert).sky-alert-success:before,:is(.sky-theme-modern .sky-alert).sky-alert-warning:before,:is(.sky-theme-modern .sky-alert).sky-alert-danger:before{display:none}:is(.sky-theme-modern .sky-alert):not(.sky-alert-danger){--sky-icon-stack-top-icon-color-override: #212327}:is(.sky-theme-modern .sky-alert).sky-alert-info{background-color:var(--sky-background-color-info-light);border-color:var(--sky-highlight-color-info)}:is(.sky-theme-modern .sky-alert).sky-alert-info:before{content:\"\\f06a\";margin-left:-31px;margin-right:20px}:is(.sky-theme-modern .sky-alert).sky-alert-success{background-color:var(--sky-background-color-success);border-color:var(--sky-highlight-color-success)}:is(.sky-theme-modern .sky-alert).sky-alert-success:before{content:\"\\f00c\"}:is(.sky-theme-modern .sky-alert).sky-alert-warning{background-color:var(--sky-background-color-warning);border-color:var(--sky-highlight-color-warning)}:is(.sky-theme-modern .sky-alert).sky-alert-warning:before{content:\"\\f071\"}:is(.sky-theme-modern .sky-alert).sky-alert-danger{background-color:var(--sky-background-color-danger);border-color:var(--sky-highlight-color-danger)}:is(.sky-theme-modern .sky-alert).sky-alert-danger:before{content:\"\\f071\"}:is(.sky-theme-modern .sky-alert) .sky-alert-close{cursor:pointer;font-weight:700;line-height:1;margin:0;padding:0;color:var(--sky-text-color-default);border:none;border-radius:6px;background-color:transparent;display:none;flex-shrink:0}:is(.sky-theme-modern .sky-alert) .sky-alert-close:hover{opacity:1;border:var(--sky-background-color-primary-dark) solid 1px}:is(.sky-theme-modern .sky-alert) .sky-alert-close:focus-visible{border:var(--sky-background-color-primary-dark) solid 2px;outline:none}:is(.sky-theme-modern .sky-alert) .sky-alert-close:active{border:var(--sky-background-color-primary-dark) solid 2px}:is(.sky-theme-modern .sky-alert) .sky-alert-close:focus-visible:not(:active){box-shadow:0 1px 3px #0000004d}:is(.sky-theme-modern .sky-alert).sky-alert-closeable .sky-alert-close{display:block}:is(.sky-theme-modern .sky-alert) .sky-alert-icon-theme-modern{display:block}:is(.sky-theme-modern .sky-alert).sky-alert-info .sky-alert-icon-theme-modern{color:var(--sky-highlight-color-info)}:is(.sky-theme-modern .sky-alert).sky-alert-success .sky-alert-icon-theme-modern{color:var(--sky-highlight-color-success)}:is(.sky-theme-modern .sky-alert).sky-alert-warning .sky-alert-icon-theme-modern{color:var(--sky-highlight-color-warning)}:is(.sky-theme-modern .sky-alert).sky-alert-danger .sky-alert-icon-theme-modern{color:var(--sky-highlight-color-danger)}\n"] }]
        }], propDecorators: { alertType: [{
                type: Input
            }], closeable: [{
                type: Input
            }], closed: [{
                type: Input
            }], descriptionType: [{
                type: Input
            }], customDescription: [{
                type: Input
            }], closedChange: [{
                type: Output
            }] } });

class SkyAlertModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyAlertModule, declarations: [SkyAlertComponent], imports: [CommonModule,
            SkyIconModule,
            SkyIndicatorsResourcesModule,
            SkyThemeModule], exports: [SkyAlertComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyAlertModule, imports: [CommonModule,
            SkyIconModule,
            SkyIndicatorsResourcesModule,
            SkyThemeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SkyAlertComponent],
                    imports: [
                        CommonModule,
                        SkyIconModule,
                        SkyIndicatorsResourcesModule,
                        SkyThemeModule,
                    ],
                    exports: [SkyAlertComponent],
                }]
        }] });

/**
 * Displays a chevron icon.
 * @internal
 */
class SkyExpansionIndicatorComponent {
    constructor() {
        this.directionOrDefault = 'up';
    }
    /**
     * The direction that the chevron points, which can be up or down.
     */
    set direction(value) {
        /* istanbul ignore else */
        if (value !== this.directionOrDefault) {
            this.directionOrDefault = value ? value : 'up';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyExpansionIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyExpansionIndicatorComponent, selector: "sky-expansion-indicator", inputs: { direction: "direction" }, ngImport: i0, template: "<div\n  aria-hidden=\"true\"\n  class=\"sky-expansion-indicator\"\n  [ngClass]=\"['sky-expansion-indicator-' + directionOrDefault]\"\n>\n  <ng-container *skyThemeIf=\"'default'\">\n    <ng-container *ngTemplateOutlet=\"icon\"></ng-container>\n  </ng-container>\n  <ng-container *skyThemeIf=\"'modern'\">\n    <span class=\"sky-expansion-indicator-glyph-container\">\n      <ng-container *ngTemplateOutlet=\"icon\"></ng-container>\n    </span>\n  </ng-container>\n</div>\n\n<ng-template #icon>\n  <i class=\"sky-expansion-indicator-part sky-expansion-indicator-left\"> </i>\n  <i class=\"sky-expansion-indicator-part sky-expansion-indicator-right\"> </i>\n</ng-template>\n", styles: [".sky-expansion-indicator:not(.sky-theme-modern *){display:inline-block;border:none;background-color:transparent;flex-shrink:0;height:24px;margin:0;overflow:hidden;width:24px;position:relative;vertical-align:top}.sky-expansion-indicator-part:not(.sky-theme-modern *){border-color:#cdcfd2;border-style:solid;border-width:3px 0 0 0;display:inline-block;height:10px;position:absolute;top:10px;transition:transform .25s,left .25s;vertical-align:top;width:10px}.sky-expansion-indicator-up:not(.sky-theme-modern *) .sky-expansion-indicator-left{left:7px;transform:rotate(-45deg)}.sky-expansion-indicator-up:not(.sky-theme-modern *) .sky-expansion-indicator-right{left:7px;transform:rotate(45deg)}.sky-expansion-indicator-down:not(.sky-theme-modern *) .sky-expansion-indicator-left{left:2px;transform:rotate(45deg)}.sky-expansion-indicator-down:not(.sky-theme-modern *) .sky-expansion-indicator-right{left:12px;transform:rotate(-45deg)}\n", ":is(.sky-theme-modern .sky-expansion-indicator){display:inline-block;border:none;background-color:transparent;flex-shrink:0;height:26px;margin:0;overflow:hidden;position:relative;vertical-align:top;width:26px}:is(.sky-theme-modern .sky-expansion-indicator-part){background:#686c73;border:none;display:inline-block;height:2px;position:absolute;top:13px;transition:transform .25s,left .25s;vertical-align:top;width:11px}:is(.sky-theme-modern .sky-expansion-indicator-glyph-container){left:4px;display:inline-block;position:absolute;top:3.5px;transform:scale(.68)}:is(.sky-theme-modern .sky-expansion-indicator-left){border-radius:1px 0 0 1px;left:4px}:is(.sky-theme-modern .sky-expansion-indicator-right){border-radius:0 1px 1px 0;left:10.5px}:is(.sky-theme-modern .sky-expansion-indicator-up) .sky-expansion-indicator-left{transform:rotate(-45deg)}:is(.sky-theme-modern .sky-expansion-indicator-up) .sky-expansion-indicator-right{transform:rotate(45deg)}:is(.sky-theme-modern .sky-expansion-indicator-down) .sky-expansion-indicator-left{transform:rotate(45deg)}:is(.sky-theme-modern .sky-expansion-indicator-down) .sky-expansion-indicator-right{transform:rotate(-45deg)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.λ3, selector: "[skyThemeIf]", inputs: ["skyThemeIf"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyExpansionIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-expansion-indicator', template: "<div\n  aria-hidden=\"true\"\n  class=\"sky-expansion-indicator\"\n  [ngClass]=\"['sky-expansion-indicator-' + directionOrDefault]\"\n>\n  <ng-container *skyThemeIf=\"'default'\">\n    <ng-container *ngTemplateOutlet=\"icon\"></ng-container>\n  </ng-container>\n  <ng-container *skyThemeIf=\"'modern'\">\n    <span class=\"sky-expansion-indicator-glyph-container\">\n      <ng-container *ngTemplateOutlet=\"icon\"></ng-container>\n    </span>\n  </ng-container>\n</div>\n\n<ng-template #icon>\n  <i class=\"sky-expansion-indicator-part sky-expansion-indicator-left\"> </i>\n  <i class=\"sky-expansion-indicator-part sky-expansion-indicator-right\"> </i>\n</ng-template>\n", styles: [".sky-expansion-indicator:not(.sky-theme-modern *){display:inline-block;border:none;background-color:transparent;flex-shrink:0;height:24px;margin:0;overflow:hidden;width:24px;position:relative;vertical-align:top}.sky-expansion-indicator-part:not(.sky-theme-modern *){border-color:#cdcfd2;border-style:solid;border-width:3px 0 0 0;display:inline-block;height:10px;position:absolute;top:10px;transition:transform .25s,left .25s;vertical-align:top;width:10px}.sky-expansion-indicator-up:not(.sky-theme-modern *) .sky-expansion-indicator-left{left:7px;transform:rotate(-45deg)}.sky-expansion-indicator-up:not(.sky-theme-modern *) .sky-expansion-indicator-right{left:7px;transform:rotate(45deg)}.sky-expansion-indicator-down:not(.sky-theme-modern *) .sky-expansion-indicator-left{left:2px;transform:rotate(45deg)}.sky-expansion-indicator-down:not(.sky-theme-modern *) .sky-expansion-indicator-right{left:12px;transform:rotate(-45deg)}\n", ":is(.sky-theme-modern .sky-expansion-indicator){display:inline-block;border:none;background-color:transparent;flex-shrink:0;height:26px;margin:0;overflow:hidden;position:relative;vertical-align:top;width:26px}:is(.sky-theme-modern .sky-expansion-indicator-part){background:#686c73;border:none;display:inline-block;height:2px;position:absolute;top:13px;transition:transform .25s,left .25s;vertical-align:top;width:11px}:is(.sky-theme-modern .sky-expansion-indicator-glyph-container){left:4px;display:inline-block;position:absolute;top:3.5px;transform:scale(.68)}:is(.sky-theme-modern .sky-expansion-indicator-left){border-radius:1px 0 0 1px;left:4px}:is(.sky-theme-modern .sky-expansion-indicator-right){border-radius:0 1px 1px 0;left:10.5px}:is(.sky-theme-modern .sky-expansion-indicator-up) .sky-expansion-indicator-left{transform:rotate(-45deg)}:is(.sky-theme-modern .sky-expansion-indicator-up) .sky-expansion-indicator-right{transform:rotate(45deg)}:is(.sky-theme-modern .sky-expansion-indicator-down) .sky-expansion-indicator-left{transform:rotate(45deg)}:is(.sky-theme-modern .sky-expansion-indicator-down) .sky-expansion-indicator-right{transform:rotate(-45deg)}\n"] }]
        }], propDecorators: { direction: [{
                type: Input
            }] } });

class SkyExpansionIndicatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyExpansionIndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyExpansionIndicatorModule, declarations: [SkyExpansionIndicatorComponent], imports: [CommonModule, SkyThemeModule], exports: [SkyExpansionIndicatorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyExpansionIndicatorModule, imports: [CommonModule, SkyThemeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyExpansionIndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SkyExpansionIndicatorComponent],
                    imports: [CommonModule, SkyThemeModule],
                    exports: [SkyExpansionIndicatorComponent],
                }]
        }] });

/**
 * Creates an accessible button that wraps the chevron icon.
 * @internal
 */
class SkyChevronComponent {
    constructor() {
        /**
         * Whether to disable the chevron button.
         */
        this.disabled = false;
        /**
         * Fires when the direction of the chevron changes.
         */
        this.directionChange = new EventEmitter();
        this.ariaExpanded = true;
        this.directionOrDefault = 'up';
    }
    /**
     * The direction that the chevron points, which can be up or down.
     */
    set direction(value) {
        /* istanbul ignore else */
        if (value !== this.directionOrDefault) {
            this.directionOrDefault = value ? value : 'up';
            /* istanbul ignore else */
            if (this.directionOrDefault === 'up') {
                this.ariaExpanded = true;
            }
            else if (this.directionOrDefault === 'down') {
                this.ariaExpanded = false;
            }
        }
    }
    chevronClick(event) {
        event.stopPropagation();
        this.direction = this.directionOrDefault === 'up' ? 'down' : 'up';
        this.directionChange.emit(this.directionOrDefault);
    }
    chevronKeyDown(event) {
        /* istanbul ignore else */
        if (event.key) {
            switch (event.key.toLowerCase()) {
                case ' ':
                case 'enter':
                    this.direction = this.directionOrDefault === 'up' ? 'down' : 'up';
                    this.directionChange.emit(this.directionOrDefault);
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                default:
                    break;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyChevronComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyChevronComponent, selector: "sky-chevron", inputs: { ariaControls: "ariaControls", ariaLabel: "ariaLabel", direction: "direction", disabled: "disabled" }, outputs: { directionChange: "directionChange" }, hostDirectives: [{ directive: i1.SkyThemeComponentClassDirective }], ngImport: i0, template: "<button\n  class=\"sky-chevron\"\n  type=\"button\"\n  [attr.aria-controls]=\"ariaControls\"\n  [attr.aria-expanded]=\"ariaExpanded\"\n  [attr.aria-label]=\"ariaLabel\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"['sky-chevron-' + directionOrDefault]\"\n  [skyThemeClass]=\"{\n    'sky-btn sky-btn-icon-borderless': 'modern'\n  }\"\n  (click)=\"chevronClick($event)\"\n  (keydown)=\"chevronKeyDown($event)\"\n>\n  <sky-expansion-indicator\n    [direction]=\"directionOrDefault\"\n  ></sky-expansion-indicator>\n</button>\n", styles: [".sky-chevron:not(.sky-theme-modern *){border:none;background-color:transparent;flex-shrink:0;height:24px;margin:0;padding:0;overflow:hidden;width:24px;cursor:pointer;position:relative;vertical-align:top}.sky-chevron:not(.sky-theme-modern *):hover .sky-chevron-part{border-color:#979ba2}\n", ":is(.sky-theme-modern .sky-chevron){border:none;background-color:transparent;flex-shrink:0;height:24px;margin:0;padding:0;overflow:hidden;width:24px;cursor:pointer;position:relative;vertical-align:top}:is(.sky-theme-modern .sky-chevron):hover .sky-chevron-part{border-color:#979ba2}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.λ2, selector: "[skyThemeClass]", inputs: ["class", "skyThemeClass"] }, { kind: "component", type: SkyExpansionIndicatorComponent, selector: "sky-expansion-indicator", inputs: ["direction"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyChevronComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-chevron', hostDirectives: [SkyThemeComponentClassDirective], template: "<button\n  class=\"sky-chevron\"\n  type=\"button\"\n  [attr.aria-controls]=\"ariaControls\"\n  [attr.aria-expanded]=\"ariaExpanded\"\n  [attr.aria-label]=\"ariaLabel\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"['sky-chevron-' + directionOrDefault]\"\n  [skyThemeClass]=\"{\n    'sky-btn sky-btn-icon-borderless': 'modern'\n  }\"\n  (click)=\"chevronClick($event)\"\n  (keydown)=\"chevronKeyDown($event)\"\n>\n  <sky-expansion-indicator\n    [direction]=\"directionOrDefault\"\n  ></sky-expansion-indicator>\n</button>\n", styles: [".sky-chevron:not(.sky-theme-modern *){border:none;background-color:transparent;flex-shrink:0;height:24px;margin:0;padding:0;overflow:hidden;width:24px;cursor:pointer;position:relative;vertical-align:top}.sky-chevron:not(.sky-theme-modern *):hover .sky-chevron-part{border-color:#979ba2}\n", ":is(.sky-theme-modern .sky-chevron){border:none;background-color:transparent;flex-shrink:0;height:24px;margin:0;padding:0;overflow:hidden;width:24px;cursor:pointer;position:relative;vertical-align:top}:is(.sky-theme-modern .sky-chevron):hover .sky-chevron-part{border-color:#979ba2}\n"] }]
        }], propDecorators: { ariaControls: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], direction: [{
                type: Input
            }], disabled: [{
                type: Input
            }], directionChange: [{
                type: Output
            }] } });

class SkyChevronModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyChevronModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyChevronModule, declarations: [SkyChevronComponent], imports: [CommonModule,
            SkyIndicatorsResourcesModule,
            SkyThemeModule,
            SkyExpansionIndicatorModule], exports: [SkyChevronComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyChevronModule, imports: [CommonModule,
            SkyIndicatorsResourcesModule,
            SkyThemeModule,
            SkyExpansionIndicatorModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyChevronModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SkyChevronComponent],
                    imports: [
                        CommonModule,
                        SkyIndicatorsResourcesModule,
                        SkyThemeModule,
                        SkyExpansionIndicatorModule,
                    ],
                    exports: [SkyChevronComponent],
                }]
        }] });

class SkyHelpInlineAriaExpandedPipe {
    transform(ariaExpanded, ariaControls) {
        return ariaControls ? !!ariaExpanded : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineAriaExpandedPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineAriaExpandedPipe, name: "skyHelpInlineAriaExpanded" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineAriaExpandedPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'skyHelpInlineAriaExpanded',
                }]
        }] });

/**
 * @deprecated Use the help inline button component in the `@skyux/help-inline` library instead.
 */
class SkyHelpInlineComponent {
    constructor() {
        /**
         * Fires when the user clicks the help inline button.
         */
        this.actionClick = new EventEmitter();
        inject(SkyLogService).deprecated('SkyHelpInlineComponent', {
            deprecationMajorVersion: 10,
            replacementRecommendation: 'Use the help inline button component in the `@skyux/help-inline` library instead.',
        });
    }
    onClick() {
        this.actionClick.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyHelpInlineComponent, selector: "sky-help-inline", inputs: { ariaControls: "ariaControls", ariaExpanded: "ariaExpanded", ariaLabel: "ariaLabel" }, outputs: { actionClick: "actionClick" }, ngImport: i0, template: "<button\n  class=\"sky-help-inline\"\n  type=\"button\"\n  [attr.aria-label]=\"\n    ariaLabel || 'skyux_help_inline_button_title' | skyLibResources\n  \"\n  [attr.aria-controls]=\"ariaControls\"\n  [attr.aria-expanded]=\"ariaExpanded | skyHelpInlineAriaExpanded: ariaControls\"\n  (click)=\"onClick()\"\n>\n  <sky-icon *skyThemeIf=\"'default'\" icon=\"info-circle\" />\n  <sky-icon-stack\n    *skyThemeIf=\"'modern'\"\n    size=\"xs\"\n    [baseIcon]=\"{\n      icon: 'circle-solid',\n      iconType: 'skyux'\n    }\"\n    [topIcon]=\"{\n      icon: 'help-i',\n      iconType: 'skyux'\n    }\"\n  >\n  </sky-icon-stack>\n</button>\n", styles: [".sky-help-inline{color:#0974a1;font-size:15px;background-color:transparent;border:none;display:inline-block}.sky-help-inline:hover{color:#065171;transition:color .15s;cursor:pointer}:host-context(.sky-theme-modern) .sky-help-inline{border-radius:3px;border:none;box-shadow:inset 0 0 0 1px transparent;background-color:transparent;color:#1870b8;padding:1px 6px}:host-context(.sky-theme-modern) .sky-help-inline ::ng-deep .fa-stack-2x{font-size:16px}:host-context(.sky-theme-modern) .sky-help-inline ::ng-deep .fa-stack-1x{font-size:10px}:host-context(.sky-theme-modern) .sky-help-inline:hover{border:none;box-shadow:inset 0 0 0 1px #1870b8;text-decoration:none}:host-context(.sky-theme-modern) .sky-help-inline:hover,:host-context(.sky-theme-modern) .sky-help-inline:active,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-active{color:#1870b8}:host-context(.sky-theme-modern) .sky-help-inline:active,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-active{border:none;box-shadow:inset 0 0 0 2px #1870b8;background-image:none}:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled:hover,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled:focus-visible,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled.sky-btn-focus,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled:active,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled.sky-btn-active,:host-context(.sky-theme-modern) .sky-help-inline[disabled],:host-context(.sky-theme-modern) .sky-help-inline[disabled]:hover,:host-context(.sky-theme-modern) .sky-help-inline[disabled]:focus-visible,:host-context(.sky-theme-modern) .sky-help-inline[disabled].sky-btn-focus,:host-context(.sky-theme-modern) .sky-help-inline[disabled]:active,:host-context(.sky-theme-modern) .sky-help-inline[disabled].sky-btn-active{border:none;box-shadow:inset 0 0 0 1px #d2d2d2;background-color:#ededee;color:#686c73;opacity:1}:host-context(.sky-theme-modern) .sky-help-inline:focus-visible{outline:none}:host-context(.sky-theme-modern) .sky-help-inline:focus-visible:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 8px #0000004d}.sky-theme-modern .sky-help-inline{border-radius:3px;border:none;box-shadow:inset 0 0 0 1px transparent;background-color:transparent;color:#1870b8;padding:1px 6px}.sky-theme-modern .sky-help-inline ::ng-deep .fa-stack-2x{font-size:16px}.sky-theme-modern .sky-help-inline ::ng-deep .fa-stack-1x{font-size:10px}.sky-theme-modern .sky-help-inline:hover{border:none;box-shadow:inset 0 0 0 1px #1870b8;text-decoration:none}.sky-theme-modern .sky-help-inline:hover,.sky-theme-modern .sky-help-inline:active,.sky-theme-modern .sky-help-inline.sky-btn-active{color:#1870b8}.sky-theme-modern .sky-help-inline:active,.sky-theme-modern .sky-help-inline.sky-btn-active{border:none;box-shadow:inset 0 0 0 2px #1870b8;background-image:none}.sky-theme-modern .sky-help-inline.sky-btn-disabled,.sky-theme-modern .sky-help-inline.sky-btn-disabled:hover,.sky-theme-modern .sky-help-inline.sky-btn-disabled:focus-visible,.sky-theme-modern .sky-help-inline.sky-btn-disabled.sky-btn-focus,.sky-theme-modern .sky-help-inline.sky-btn-disabled:active,.sky-theme-modern .sky-help-inline.sky-btn-disabled.sky-btn-active,.sky-theme-modern .sky-help-inline[disabled],.sky-theme-modern .sky-help-inline[disabled]:hover,.sky-theme-modern .sky-help-inline[disabled]:focus-visible,.sky-theme-modern .sky-help-inline[disabled].sky-btn-focus,.sky-theme-modern .sky-help-inline[disabled]:active,.sky-theme-modern .sky-help-inline[disabled].sky-btn-active{border:none;box-shadow:inset 0 0 0 1px #d2d2d2;background-color:#ededee;color:#686c73;opacity:1}.sky-theme-modern .sky-help-inline:focus-visible{outline:none}.sky-theme-modern .sky-help-inline:focus-visible:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 8px #0000004d}\n"], dependencies: [{ kind: "component", type: i3.λ1, selector: "sky-icon", inputs: ["icon", "iconName", "iconType", "size", "fixedWidth", "variant"] }, { kind: "component", type: i3.λ2, selector: "sky-icon-stack", inputs: ["size", "baseIcon", "topIcon"] }, { kind: "directive", type: i1.λ3, selector: "[skyThemeIf]", inputs: ["skyThemeIf"] }, { kind: "pipe", type: i4.SkyLibResourcesPipe, name: "skyLibResources" }, { kind: "pipe", type: SkyHelpInlineAriaExpandedPipe, name: "skyHelpInlineAriaExpanded" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-help-inline', template: "<button\n  class=\"sky-help-inline\"\n  type=\"button\"\n  [attr.aria-label]=\"\n    ariaLabel || 'skyux_help_inline_button_title' | skyLibResources\n  \"\n  [attr.aria-controls]=\"ariaControls\"\n  [attr.aria-expanded]=\"ariaExpanded | skyHelpInlineAriaExpanded: ariaControls\"\n  (click)=\"onClick()\"\n>\n  <sky-icon *skyThemeIf=\"'default'\" icon=\"info-circle\" />\n  <sky-icon-stack\n    *skyThemeIf=\"'modern'\"\n    size=\"xs\"\n    [baseIcon]=\"{\n      icon: 'circle-solid',\n      iconType: 'skyux'\n    }\"\n    [topIcon]=\"{\n      icon: 'help-i',\n      iconType: 'skyux'\n    }\"\n  >\n  </sky-icon-stack>\n</button>\n", styles: [".sky-help-inline{color:#0974a1;font-size:15px;background-color:transparent;border:none;display:inline-block}.sky-help-inline:hover{color:#065171;transition:color .15s;cursor:pointer}:host-context(.sky-theme-modern) .sky-help-inline{border-radius:3px;border:none;box-shadow:inset 0 0 0 1px transparent;background-color:transparent;color:#1870b8;padding:1px 6px}:host-context(.sky-theme-modern) .sky-help-inline ::ng-deep .fa-stack-2x{font-size:16px}:host-context(.sky-theme-modern) .sky-help-inline ::ng-deep .fa-stack-1x{font-size:10px}:host-context(.sky-theme-modern) .sky-help-inline:hover{border:none;box-shadow:inset 0 0 0 1px #1870b8;text-decoration:none}:host-context(.sky-theme-modern) .sky-help-inline:hover,:host-context(.sky-theme-modern) .sky-help-inline:active,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-active{color:#1870b8}:host-context(.sky-theme-modern) .sky-help-inline:active,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-active{border:none;box-shadow:inset 0 0 0 2px #1870b8;background-image:none}:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled:hover,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled:focus-visible,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled.sky-btn-focus,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled:active,:host-context(.sky-theme-modern) .sky-help-inline.sky-btn-disabled.sky-btn-active,:host-context(.sky-theme-modern) .sky-help-inline[disabled],:host-context(.sky-theme-modern) .sky-help-inline[disabled]:hover,:host-context(.sky-theme-modern) .sky-help-inline[disabled]:focus-visible,:host-context(.sky-theme-modern) .sky-help-inline[disabled].sky-btn-focus,:host-context(.sky-theme-modern) .sky-help-inline[disabled]:active,:host-context(.sky-theme-modern) .sky-help-inline[disabled].sky-btn-active{border:none;box-shadow:inset 0 0 0 1px #d2d2d2;background-color:#ededee;color:#686c73;opacity:1}:host-context(.sky-theme-modern) .sky-help-inline:focus-visible{outline:none}:host-context(.sky-theme-modern) .sky-help-inline:focus-visible:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 8px #0000004d}.sky-theme-modern .sky-help-inline{border-radius:3px;border:none;box-shadow:inset 0 0 0 1px transparent;background-color:transparent;color:#1870b8;padding:1px 6px}.sky-theme-modern .sky-help-inline ::ng-deep .fa-stack-2x{font-size:16px}.sky-theme-modern .sky-help-inline ::ng-deep .fa-stack-1x{font-size:10px}.sky-theme-modern .sky-help-inline:hover{border:none;box-shadow:inset 0 0 0 1px #1870b8;text-decoration:none}.sky-theme-modern .sky-help-inline:hover,.sky-theme-modern .sky-help-inline:active,.sky-theme-modern .sky-help-inline.sky-btn-active{color:#1870b8}.sky-theme-modern .sky-help-inline:active,.sky-theme-modern .sky-help-inline.sky-btn-active{border:none;box-shadow:inset 0 0 0 2px #1870b8;background-image:none}.sky-theme-modern .sky-help-inline.sky-btn-disabled,.sky-theme-modern .sky-help-inline.sky-btn-disabled:hover,.sky-theme-modern .sky-help-inline.sky-btn-disabled:focus-visible,.sky-theme-modern .sky-help-inline.sky-btn-disabled.sky-btn-focus,.sky-theme-modern .sky-help-inline.sky-btn-disabled:active,.sky-theme-modern .sky-help-inline.sky-btn-disabled.sky-btn-active,.sky-theme-modern .sky-help-inline[disabled],.sky-theme-modern .sky-help-inline[disabled]:hover,.sky-theme-modern .sky-help-inline[disabled]:focus-visible,.sky-theme-modern .sky-help-inline[disabled].sky-btn-focus,.sky-theme-modern .sky-help-inline[disabled]:active,.sky-theme-modern .sky-help-inline[disabled].sky-btn-active{border:none;box-shadow:inset 0 0 0 1px #d2d2d2;background-color:#ededee;color:#686c73;opacity:1}.sky-theme-modern .sky-help-inline:focus-visible{outline:none}.sky-theme-modern .sky-help-inline:focus-visible:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 8px #0000004d}\n"] }]
        }], ctorParameters: () => [], propDecorators: { ariaControls: [{
                type: Input
            }], ariaExpanded: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], actionClick: [{
                type: Output
            }] } });

class SkyHelpInlineModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineModule, declarations: [SkyHelpInlineComponent, SkyHelpInlineAriaExpandedPipe], imports: [CommonModule,
            SkyIconModule,
            SkyIndicatorsResourcesModule,
            SkyThemeModule], exports: [SkyHelpInlineComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineModule, imports: [CommonModule,
            SkyIconModule,
            SkyIndicatorsResourcesModule,
            SkyThemeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyHelpInlineModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SkyHelpInlineComponent, SkyHelpInlineAriaExpandedPipe],
                    imports: [
                        CommonModule,
                        SkyIconModule,
                        SkyIndicatorsResourcesModule,
                        SkyThemeModule,
                    ],
                    exports: [SkyHelpInlineComponent],
                }]
        }] });

/**
 * Resolves information about spot illustrations.
 */
class SkyIllustrationResolverService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationResolverService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationResolverService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationResolverService, decorators: [{
            type: Injectable
        }] });

const pixelSizes = {
    sm: 48,
    md: 64,
    lg: 80,
    xl: 96,
};
/**
 * Displays a spot illustration at the specified size.
 */
class SkyIllustrationComponent {
    constructor() {
        this.#resolverSvc = inject(SkyIllustrationResolverService, {
            optional: true,
        });
        /**
         * The name of the illustration to display.
         * @required
         */
        this.name = input.required();
        /**
         * The size of the illustration.
         * @required
         */
        this.size = input.required();
        this.url = toSignal(toObservable(this.name).pipe(switchMap((name) => this.#resolverSvc ? from(this.#resolverSvc.resolveUrl(name)) : of('')), catchError(() => of(''))));
        this.pixelSize = computed(() => pixelSizes[this.size()]);
    }
    #resolverSvc;
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "17.3.4", type: SkyIllustrationComponent, isStandalone: true, selector: "sky-illustration", inputs: { name: { classPropertyName: "name", publicName: "name", isSignal: true, isRequired: true, transformFunction: null }, size: { classPropertyName: "size", publicName: "size", isSignal: true, isRequired: true, transformFunction: null } }, hostDirectives: [{ directive: i1.SkyThemeComponentClassDirective }], ngImport: i0, template: "<img\n  alt=\"\"\n  class=\"sky-illustration-img\"\n  loading=\"lazy\"\n  [attr.data-sky-illustration-name]=\"name()\"\n  [height]=\"pixelSize()\"\n  [ngClass]=\"{\n    'sky-illustration-img-loaded': !!url()\n  }\"\n  [src]=\"url()\"\n  [width]=\"pixelSize()\"\n/>\n", styles: [":host.sky-cmp-theme-default{display:block}.sky-illustration-img:not(.sky-theme-modern *){display:block}.sky-illustration-img:not(.sky-theme-modern *)[src=\"\"]{visibility:hidden}\n", ":host-context(.sky-theme-modern) :host.sky-cmp-theme-modern{display:block}:is(.sky-theme-modern .sky-illustration-img){display:block}:is(.sky-theme-modern .sky-illustration-img)[src=\"\"]{visibility:hidden}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-illustration', standalone: true, imports: [CommonModule, NgOptimizedImage], hostDirectives: [SkyThemeComponentClassDirective], changeDetection: ChangeDetectionStrategy.OnPush, template: "<img\n  alt=\"\"\n  class=\"sky-illustration-img\"\n  loading=\"lazy\"\n  [attr.data-sky-illustration-name]=\"name()\"\n  [height]=\"pixelSize()\"\n  [ngClass]=\"{\n    'sky-illustration-img-loaded': !!url()\n  }\"\n  [src]=\"url()\"\n  [width]=\"pixelSize()\"\n/>\n", styles: [":host.sky-cmp-theme-default{display:block}.sky-illustration-img:not(.sky-theme-modern *){display:block}.sky-illustration-img:not(.sky-theme-modern *)[src=\"\"]{visibility:hidden}\n", ":host-context(.sky-theme-modern) :host.sky-cmp-theme-modern{display:block}:is(.sky-theme-modern .sky-illustration-img){display:block}:is(.sky-theme-modern .sky-illustration-img)[src=\"\"]{visibility:hidden}\n"] }]
        }] });

class SkyIllustrationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationModule, imports: [SkyIllustrationComponent], exports: [SkyIllustrationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationModule, imports: [SkyIllustrationComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyIllustrationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [SkyIllustrationComponent],
                    exports: [SkyIllustrationComponent],
                }]
        }] });

/**
 * Specifies a label to display in smaller text under or beside the value.
 * To display a help button beside the label, include a help button element, such as `sky-help-inline`,
 * in the `sky-key-info` element and a `sky-control-help` CSS class on that help button element.
 * @required
 */
class SkyKeyInfoLabelComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyKeyInfoLabelComponent, selector: "sky-key-info-label", ngImport: i0, template: '<span skyTrim><ng-content /></span>', isInline: true, dependencies: [{ kind: "directive", type: i3$1.λ4, selector: "[skyTrim]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoLabelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sky-key-info-label',
                    template: '<span skyTrim><ng-content /></span>',
                }]
        }] });

/**
 * Specifies a value to display in larger, bold text.
 * @required
 */
class SkyKeyInfoValueComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoValueComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyKeyInfoValueComponent, selector: "sky-key-info-value", ngImport: i0, template: '<ng-content />', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoValueComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sky-key-info-value',
                    template: '<ng-content />',
                }]
        }] });

class SkyKeyInfoComponent {
    constructor() {
        /**
         * The layout for the key info. The vertical layout places the label under the
         * value, while the horizontal layout places the label beside the value.
         * @default "vertical"
         */
        this.layout = 'vertical';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyKeyInfoComponent, selector: "sky-key-info", inputs: { helpKey: "helpKey", helpPopoverContent: "helpPopoverContent", helpPopoverTitle: "helpPopoverTitle", layout: "layout" }, ngImport: i0, template: "<div\n  class=\"sky-key-info\"\n  [ngClass]=\"{\n    'sky-key-info-horizontal': layout === 'horizontal'\n  }\"\n>\n  <div class=\"sky-key-info-value sky-font-display-3\">\n    <ng-content select=\"sky-key-info-value\" />\n  </div>\n  <div class=\"sky-key-info-label sky-field-label sky-font-data-label\">\n    <span skyId #label=\"skyId\"><ng-content select=\"sky-key-info-label\" /></span\n    ><span class=\"sky-control-help-container\"\n      ><sky-help-inline\n        *ngIf=\"helpPopoverContent || helpKey; else helpContent\"\n        [labelledBy]=\"label.id\"\n        [helpKey]=\"helpKey\"\n        [popoverTitle]=\"helpPopoverTitle\"\n        [popoverContent]=\"helpPopoverContent\"\n    /></span>\n  </div>\n</div>\n<ng-template #helpContent\n  ><ng-content select=\".sky-control-help\"\n/></ng-template>\n", styles: [".sky-key-info:not(.sky-theme-modern *){display:inline-block}.sky-key-info:not(.sky-theme-modern *).sky-key-info-horizontal .sky-key-info-value,.sky-key-info:not(.sky-theme-modern *).sky-key-info-horizontal .sky-key-info-label{display:inline-block}.sky-key-info:not(.sky-theme-modern *).sky-key-info-horizontal .sky-key-info-label{padding:0 0 0 var(--sky-margin-inline-xs)}\n", ":is(.sky-theme-modern .sky-key-info){display:inline-block}:is(.sky-theme-modern .sky-key-info).sky-key-info-horizontal .sky-key-info-value,:is(.sky-theme-modern .sky-key-info).sky-key-info-horizontal .sky-key-info-label{display:inline-block}:is(.sky-theme-modern .sky-key-info).sky-key-info-horizontal .sky-key-info-label{padding:0 0 0 var(--sky-margin-inline-xs)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.λ1, selector: "sky-help-inline", inputs: ["ariaControls", "ariaExpanded", "ariaLabel", "helpKey", "labelledBy", "labelText", "popoverContent", "popoverTitle"], outputs: ["actionClick"] }, { kind: "directive", type: i3$1.λ2, selector: "[skyId]", exportAs: ["skyId"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-key-info', template: "<div\n  class=\"sky-key-info\"\n  [ngClass]=\"{\n    'sky-key-info-horizontal': layout === 'horizontal'\n  }\"\n>\n  <div class=\"sky-key-info-value sky-font-display-3\">\n    <ng-content select=\"sky-key-info-value\" />\n  </div>\n  <div class=\"sky-key-info-label sky-field-label sky-font-data-label\">\n    <span skyId #label=\"skyId\"><ng-content select=\"sky-key-info-label\" /></span\n    ><span class=\"sky-control-help-container\"\n      ><sky-help-inline\n        *ngIf=\"helpPopoverContent || helpKey; else helpContent\"\n        [labelledBy]=\"label.id\"\n        [helpKey]=\"helpKey\"\n        [popoverTitle]=\"helpPopoverTitle\"\n        [popoverContent]=\"helpPopoverContent\"\n    /></span>\n  </div>\n</div>\n<ng-template #helpContent\n  ><ng-content select=\".sky-control-help\"\n/></ng-template>\n", styles: [".sky-key-info:not(.sky-theme-modern *){display:inline-block}.sky-key-info:not(.sky-theme-modern *).sky-key-info-horizontal .sky-key-info-value,.sky-key-info:not(.sky-theme-modern *).sky-key-info-horizontal .sky-key-info-label{display:inline-block}.sky-key-info:not(.sky-theme-modern *).sky-key-info-horizontal .sky-key-info-label{padding:0 0 0 var(--sky-margin-inline-xs)}\n", ":is(.sky-theme-modern .sky-key-info){display:inline-block}:is(.sky-theme-modern .sky-key-info).sky-key-info-horizontal .sky-key-info-value,:is(.sky-theme-modern .sky-key-info).sky-key-info-horizontal .sky-key-info-label{display:inline-block}:is(.sky-theme-modern .sky-key-info).sky-key-info-horizontal .sky-key-info-label{padding:0 0 0 var(--sky-margin-inline-xs)}\n"] }]
        }], propDecorators: { helpKey: [{
                type: Input
            }], helpPopoverContent: [{
                type: Input
            }], helpPopoverTitle: [{
                type: Input
            }], layout: [{
                type: Input
            }] } });

class SkyKeyInfoModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoModule, declarations: [SkyKeyInfoComponent,
            SkyKeyInfoLabelComponent,
            SkyKeyInfoValueComponent], imports: [CommonModule, SkyTrimModule, SkyHelpInlineModule$1, SkyIdModule], exports: [SkyKeyInfoComponent,
            SkyKeyInfoLabelComponent,
            SkyKeyInfoValueComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoModule, imports: [CommonModule, SkyTrimModule, SkyHelpInlineModule$1, SkyIdModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyKeyInfoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SkyKeyInfoComponent,
                        SkyKeyInfoLabelComponent,
                        SkyKeyInfoValueComponent,
                    ],
                    imports: [CommonModule, SkyTrimModule, SkyHelpInlineModule$1, SkyIdModule],
                    exports: [
                        SkyKeyInfoComponent,
                        SkyKeyInfoLabelComponent,
                        SkyKeyInfoValueComponent,
                    ],
                }]
        }] });

const LABEL_TYPE_DEFAULT = 'info';
class SkyLabelComponent {
    constructor() {
        this.labelTypeOrDefault = LABEL_TYPE_DEFAULT;
        this.#changeDetector = inject(ChangeDetectorRef);
        this.#resources = inject(SkyLibResourcesService);
        this.#logSvc = inject(SkyLogService);
    }
    /**
     * The type of label to display.
     * @default 'info'
     */
    set labelType(value) {
        this.labelTypeOrDefault = value === undefined ? LABEL_TYPE_DEFAULT : value;
        this.#updateIcon();
    }
    /**
     * The predefined text to be read by screen readers for users who cannot see the indicator icon.
     * This property is optional but will be required in future versions of SKY UX.
     */
    set descriptionType(value) {
        this.#_descriptionType = value;
        this.#updateDescriptionComputed();
    }
    get descriptionType() {
        return this.#_descriptionType;
    }
    /**
     * The text to be read by screen readers for users who cannot see
     * the indicator icon when `descriptionType` is `custom`.
     */
    set customDescription(value) {
        this.#_customDescription = value;
        this.#updateDescriptionComputed();
    }
    get customDescription() {
        return this.#_customDescription;
    }
    #_descriptionType;
    #_customDescription;
    #descriptionTypeResourceSubscription;
    #descriptionTypeWarned;
    #changeDetector;
    #resources;
    #logSvc;
    ngOnInit() {
        this.#updateIcon();
    }
    ngAfterViewChecked() {
        if (!this.descriptionType && !this.#descriptionTypeWarned) {
            this.#logSvc.deprecated('SkyLabelComponent without `descriptionType`', {
                deprecationMajorVersion: 8,
                replacementRecommendation: 'Always specify a `descriptionType` property.',
            });
            this.#descriptionTypeWarned = true;
        }
    }
    ngOnDestroy() {
        this.#unsubscribe();
    }
    #updateIcon() {
        const indicatorIcon = SkyIndicatorIconUtility.getIconsForType(this.labelTypeOrDefault);
        this.icon = indicatorIcon.defaultThemeIcon;
        this.baseIcon = indicatorIcon.modernThemeBaseIcon;
        this.topIcon = indicatorIcon.modernThemeTopIcon;
    }
    #updateDescriptionComputed() {
        this.#unsubscribe();
        if (this.descriptionType) {
            switch (this.descriptionType) {
                case 'none':
                    this.descriptionComputed = undefined;
                    break;
                case 'custom':
                    this.descriptionComputed = this.customDescription;
                    break;
                default:
                    this.#descriptionTypeResourceSubscription = this.#resources
                        .getString('skyux_label_sr_' + this.descriptionType.replace(/-/g, '_'))
                        .subscribe((value) => {
                        this.descriptionComputed = value;
                        this.#changeDetector.markForCheck();
                    });
                    break;
            }
        }
        else {
            this.descriptionComputed = undefined;
        }
    }
    #unsubscribe() {
        if (this.#descriptionTypeResourceSubscription) {
            this.#descriptionTypeResourceSubscription.unsubscribe();
            this.#descriptionTypeResourceSubscription = undefined;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyLabelComponent, selector: "sky-label", inputs: { labelType: "labelType", descriptionType: "descriptionType", customDescription: "customDescription" }, ngImport: i0, template: "<span class=\"sky-label\" [ngClass]=\"'sky-label-' + labelTypeOrDefault\">\n  <span class=\"sky-label-icon-theme-default\">\n    <sky-icon [icon]=\"icon\" />\n  </span>\n  <span class=\"sky-label-icon-theme-modern\">\n    <sky-icon-stack size=\"xs\" [baseIcon]=\"baseIcon\" [topIcon]=\"topIcon\">\n    </sky-icon-stack>\n  </span>\n  <span *ngIf=\"descriptionComputed\" class=\"sky-screen-reader-only\">\n    {{ descriptionComputed }}\n  </span>\n  <span class=\"sky-label-text\">\n    <ng-content />\n  </span>\n</span>\n", styles: [".sky-label{--sky-label-display: inline;--sky-label-align-items: initial;--sky-label-line-height: 2.2;--sky-label-info-background-color: var(--sky-background-color-info);--sky-label-icon-default-display: inline;--sky-label-icon-modern-display: none;--sky-label-info-success-padding: .3em .6em .3em .6em;--sky-label-warning-danger-padding: .3em .6em .3em .6em}:host-context(.sky-theme-modern) .sky-label{--sky-label-display: inline-flex;--sky-label-align-items: center;--sky-label-line-height: 1;--sky-label-info-background-color: var(--sky-background-color-info-light);--sky-label-icon-default-display: none;--sky-label-icon-modern-display: block;--sky-label-info-success-padding: 4px 15px 4px 6px;--sky-label-warning-danger-padding: 4px 15px 4px 9px}:host-context(.sky-theme-modern) .sky-label:not(.sky-label-danger){--sky-icon-stack-top-icon-color-override: var(--sky-text-color-default)}:host-context(.sky-theme-modern) .sky-label-info .sky-label-icon-theme-modern{color:var(--sky-highlight-color-info)}:host-context(.sky-theme-modern) .sky-label-success .sky-label-icon-theme-modern{color:var(--sky-highlight-color-success)}:host-context(.sky-theme-modern) .sky-label-warning .sky-label-icon-theme-modern{color:var(--sky-highlight-color-warning)}:host-context(.sky-theme-modern) .sky-label-danger .sky-label-icon-theme-modern{color:var(--sky-highlight-color-danger)}.sky-theme-modern .sky-label{--sky-label-display: inline-flex;--sky-label-align-items: center;--sky-label-line-height: 1;--sky-label-info-background-color: var(--sky-background-color-info-light);--sky-label-icon-default-display: none;--sky-label-icon-modern-display: block;--sky-label-info-success-padding: 4px 15px 4px 6px;--sky-label-warning-danger-padding: 4px 15px 4px 9px}.sky-theme-modern .sky-label:not(.sky-label-danger){--sky-icon-stack-top-icon-color-override: var(--sky-text-color-default)}.sky-theme-modern .sky-label-info .sky-label-icon-theme-modern{color:var(--sky-highlight-color-info)}.sky-theme-modern .sky-label-success .sky-label-icon-theme-modern{color:var(--sky-highlight-color-success)}.sky-theme-modern .sky-label-warning .sky-label-icon-theme-modern{color:var(--sky-highlight-color-warning)}.sky-theme-modern .sky-label-danger .sky-label-icon-theme-modern{color:var(--sky-highlight-color-danger)}.sky-label{color:var(--sky-text-color-default);display:var(--sky-label-display);align-items:var(--sky-label-align-items);border-radius:10rem;font-weight:400;line-height:var(--sky-label-line-height);margin:0 3px;white-space:nowrap}.sky-label.sky-label-info,.sky-label.sky-label-success{padding:var(--sky-label-info-success-padding)}.sky-label.sky-label-warning,.sky-label.sky-label-danger{padding:var(--sky-label-warning-danger-padding)}.sky-label-success{background-color:var(--sky-background-color-success)}.sky-label-info{background-color:var(--sky-label-info-background-color)}.sky-label-warning{background-color:var(--sky-background-color-warning)}.sky-label-danger{background-color:var(--sky-background-color-danger)}.sky-label-text{display:inline-block;padding-left:var(--sky-padding-half)}.sky-label-icon-theme-modern{display:var(--sky-label-icon-modern-display)}.sky-label-icon-theme-default{display:var(--sky-label-icon-default-display)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.λ1, selector: "sky-icon", inputs: ["icon", "iconName", "iconType", "size", "fixedWidth", "variant"] }, { kind: "component", type: i3.λ2, selector: "sky-icon-stack", inputs: ["size", "baseIcon", "topIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-label', template: "<span class=\"sky-label\" [ngClass]=\"'sky-label-' + labelTypeOrDefault\">\n  <span class=\"sky-label-icon-theme-default\">\n    <sky-icon [icon]=\"icon\" />\n  </span>\n  <span class=\"sky-label-icon-theme-modern\">\n    <sky-icon-stack size=\"xs\" [baseIcon]=\"baseIcon\" [topIcon]=\"topIcon\">\n    </sky-icon-stack>\n  </span>\n  <span *ngIf=\"descriptionComputed\" class=\"sky-screen-reader-only\">\n    {{ descriptionComputed }}\n  </span>\n  <span class=\"sky-label-text\">\n    <ng-content />\n  </span>\n</span>\n", styles: [".sky-label{--sky-label-display: inline;--sky-label-align-items: initial;--sky-label-line-height: 2.2;--sky-label-info-background-color: var(--sky-background-color-info);--sky-label-icon-default-display: inline;--sky-label-icon-modern-display: none;--sky-label-info-success-padding: .3em .6em .3em .6em;--sky-label-warning-danger-padding: .3em .6em .3em .6em}:host-context(.sky-theme-modern) .sky-label{--sky-label-display: inline-flex;--sky-label-align-items: center;--sky-label-line-height: 1;--sky-label-info-background-color: var(--sky-background-color-info-light);--sky-label-icon-default-display: none;--sky-label-icon-modern-display: block;--sky-label-info-success-padding: 4px 15px 4px 6px;--sky-label-warning-danger-padding: 4px 15px 4px 9px}:host-context(.sky-theme-modern) .sky-label:not(.sky-label-danger){--sky-icon-stack-top-icon-color-override: var(--sky-text-color-default)}:host-context(.sky-theme-modern) .sky-label-info .sky-label-icon-theme-modern{color:var(--sky-highlight-color-info)}:host-context(.sky-theme-modern) .sky-label-success .sky-label-icon-theme-modern{color:var(--sky-highlight-color-success)}:host-context(.sky-theme-modern) .sky-label-warning .sky-label-icon-theme-modern{color:var(--sky-highlight-color-warning)}:host-context(.sky-theme-modern) .sky-label-danger .sky-label-icon-theme-modern{color:var(--sky-highlight-color-danger)}.sky-theme-modern .sky-label{--sky-label-display: inline-flex;--sky-label-align-items: center;--sky-label-line-height: 1;--sky-label-info-background-color: var(--sky-background-color-info-light);--sky-label-icon-default-display: none;--sky-label-icon-modern-display: block;--sky-label-info-success-padding: 4px 15px 4px 6px;--sky-label-warning-danger-padding: 4px 15px 4px 9px}.sky-theme-modern .sky-label:not(.sky-label-danger){--sky-icon-stack-top-icon-color-override: var(--sky-text-color-default)}.sky-theme-modern .sky-label-info .sky-label-icon-theme-modern{color:var(--sky-highlight-color-info)}.sky-theme-modern .sky-label-success .sky-label-icon-theme-modern{color:var(--sky-highlight-color-success)}.sky-theme-modern .sky-label-warning .sky-label-icon-theme-modern{color:var(--sky-highlight-color-warning)}.sky-theme-modern .sky-label-danger .sky-label-icon-theme-modern{color:var(--sky-highlight-color-danger)}.sky-label{color:var(--sky-text-color-default);display:var(--sky-label-display);align-items:var(--sky-label-align-items);border-radius:10rem;font-weight:400;line-height:var(--sky-label-line-height);margin:0 3px;white-space:nowrap}.sky-label.sky-label-info,.sky-label.sky-label-success{padding:var(--sky-label-info-success-padding)}.sky-label.sky-label-warning,.sky-label.sky-label-danger{padding:var(--sky-label-warning-danger-padding)}.sky-label-success{background-color:var(--sky-background-color-success)}.sky-label-info{background-color:var(--sky-label-info-background-color)}.sky-label-warning{background-color:var(--sky-background-color-warning)}.sky-label-danger{background-color:var(--sky-background-color-danger)}.sky-label-text{display:inline-block;padding-left:var(--sky-padding-half)}.sky-label-icon-theme-modern{display:var(--sky-label-icon-modern-display)}.sky-label-icon-theme-default{display:var(--sky-label-icon-default-display)}\n"] }]
        }], propDecorators: { labelType: [{
                type: Input
            }], descriptionType: [{
                type: Input
            }], customDescription: [{
                type: Input
            }] } });

class SkyLabelModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyLabelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyLabelModule, declarations: [SkyLabelComponent], imports: [CommonModule, SkyIconModule, SkyIndicatorsResourcesModule], exports: [SkyLabelComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyLabelModule, imports: [CommonModule, SkyIconModule, SkyIndicatorsResourcesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyLabelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SkyLabelComponent],
                    imports: [CommonModule, SkyIconModule, SkyIndicatorsResourcesModule],
                    exports: [SkyLabelComponent],
                }]
        }] });

const INDICATOR_TYPE_DEFAULT = 'warning';
/**
 * Displays status text with an icon matching the specified indicator type.
 * To display a help button beside the label, include a help button element, such as
 * `sky-help-inline`, in the `sky-status-indicator` element and a `sky-control-help`
 * CSS class on that help button element.
 */
class SkyStatusIndicatorComponent {
    constructor() {
        this.indicatorTypeOrDefault = INDICATOR_TYPE_DEFAULT;
        this.#changeDetector = inject(ChangeDetectorRef);
        this.#resourcesSvc = inject(SkyLibResourcesService);
    }
    /**
     * The style for the status indicator, which determines the icon.
     * @default "warning"
     */
    set indicatorType(value) {
        this.indicatorTypeOrDefault =
            value === undefined ? INDICATOR_TYPE_DEFAULT : value;
        this.#updateIcon();
    }
    /**
     * The predefined text to be read by screen readers for users who
     * cannot see the indicator icon.
     * @required
     */
    set descriptionType(value) {
        this.#_descriptionType = value;
        this.#updateDescriptionComputed();
    }
    get descriptionType() {
        return this.#_descriptionType;
    }
    /**
     * The text to be read by screen readers for users who cannot see
     * the indicator icon when `descriptionType` is `custom`.
     */
    set customDescription(value) {
        this.#_customDescription = value;
        this.#updateDescriptionComputed();
    }
    get customDescription() {
        return this.#_customDescription;
    }
    #changeDetector;
    #resourcesSvc;
    #_descriptionType;
    #_customDescription;
    ngOnInit() {
        this.#updateIcon();
    }
    #updateIcon() {
        const indicatorIcon = SkyIndicatorIconUtility.getIconsForType(this.indicatorTypeOrDefault);
        this.icon = indicatorIcon.defaultThemeIcon;
        this.baseIcon = indicatorIcon.modernThemeBaseIcon;
        this.topIcon = indicatorIcon.modernThemeTopIcon;
    }
    #updateDescriptionComputed() {
        if (this.descriptionType) {
            switch (this.descriptionType) {
                case 'none':
                    this.descriptionComputed = '';
                    break;
                case 'custom':
                    this.descriptionComputed = this.customDescription;
                    break;
                default:
                    this.#resourcesSvc
                        .getString('skyux_status_indicator_sr_' +
                        this.descriptionType.replace(/-/g, '_'))
                        .subscribe((value) => {
                        this.descriptionComputed = value;
                        this.#changeDetector.markForCheck();
                    });
                    break;
            }
        }
        else {
            this.descriptionComputed = undefined;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyStatusIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyStatusIndicatorComponent, selector: "sky-status-indicator", inputs: { indicatorType: "indicatorType", descriptionType: "descriptionType", customDescription: "customDescription", helpPopoverContent: "helpPopoverContent", helpPopoverTitle: "helpPopoverTitle", helpKey: "helpKey" }, ngImport: i0, template: "<ng-template #helpContent\n  ><ng-content select=\".sky-control-help\"\n/></ng-template>\n<div *ngIf=\"descriptionType\" class=\"sky-status-indicator\">\n  <div\n    aria-hidden=\"true\"\n    class=\"sky-margin-inline-xs sky-status-indicator-icon\"\n    [ngClass]=\"'sky-status-indicator-icon-' + indicatorTypeOrDefault\"\n  >\n    <span class=\"sky-status-indicator-icon-default\">\n      <sky-icon [icon]=\"icon\" />\n    </span>\n    <span class=\"sky-status-indicator-icon-modern\">\n      <sky-icon-stack size=\"xs\" [baseIcon]=\"baseIcon\" [topIcon]=\"topIcon\">\n      </sky-icon-stack>\n    </span>\n  </div>\n  <div class=\"sky-status-indicator-message-wrapper\">\n    <span *ngIf=\"descriptionComputed\" class=\"sky-screen-reader-only\">\n      {{ descriptionComputed }}\n    </span>\n    <span skyId #message=\"skyId\" class=\"sky-status-indicator-message\" skyTrim\n      ><ng-content /></span\n    ><span class=\"sky-control-help-container\"\n      ><sky-help-inline\n        *ngIf=\"helpPopoverContent || helpKey; else helpContent\"\n        [labelledBy]=\"message.id\"\n        [helpKey]=\"helpKey\"\n        [popoverTitle]=\"helpPopoverTitle\"\n        [popoverContent]=\"helpPopoverContent\"\n    /></span>\n  </div>\n</div>\n", styles: [".sky-status-indicator{align-items:baseline;display:flex}.sky-status-indicator-icon{flex-shrink:1}.sky-status-indicator-icon-modern{display:none}.sky-status-indicator-icon-info{color:#00b4f1}.sky-status-indicator-icon-success{color:#72bf44}.sky-status-indicator-icon-warning{color:#fbb034}.sky-status-indicator-icon-danger{color:#ef4044}:host-context(.sky-theme-modern) .sky-status-indicator-icon:not(.sky-status-indicator-icon-danger){--sky-icon-stack-top-icon-color-override: #212327}:host-context(.sky-theme-modern) .sky-status-indicator-icon-default{display:none}:host-context(.sky-theme-modern) .sky-status-indicator-icon-modern{display:inline}.sky-theme-modern .sky-status-indicator-icon:not(.sky-status-indicator-icon-danger){--sky-icon-stack-top-icon-color-override: #212327}.sky-theme-modern .sky-status-indicator-icon-default{display:none}.sky-theme-modern .sky-status-indicator-icon-modern{display:inline}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.λ1, selector: "sky-help-inline", inputs: ["ariaControls", "ariaExpanded", "ariaLabel", "helpKey", "labelledBy", "labelText", "popoverContent", "popoverTitle"], outputs: ["actionClick"] }, { kind: "component", type: i3.λ1, selector: "sky-icon", inputs: ["icon", "iconName", "iconType", "size", "fixedWidth", "variant"] }, { kind: "component", type: i3.λ2, selector: "sky-icon-stack", inputs: ["size", "baseIcon", "topIcon"] }, { kind: "directive", type: i3$1.λ2, selector: "[skyId]", exportAs: ["skyId"] }, { kind: "directive", type: i3$1.λ4, selector: "[skyTrim]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyStatusIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-status-indicator', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template #helpContent\n  ><ng-content select=\".sky-control-help\"\n/></ng-template>\n<div *ngIf=\"descriptionType\" class=\"sky-status-indicator\">\n  <div\n    aria-hidden=\"true\"\n    class=\"sky-margin-inline-xs sky-status-indicator-icon\"\n    [ngClass]=\"'sky-status-indicator-icon-' + indicatorTypeOrDefault\"\n  >\n    <span class=\"sky-status-indicator-icon-default\">\n      <sky-icon [icon]=\"icon\" />\n    </span>\n    <span class=\"sky-status-indicator-icon-modern\">\n      <sky-icon-stack size=\"xs\" [baseIcon]=\"baseIcon\" [topIcon]=\"topIcon\">\n      </sky-icon-stack>\n    </span>\n  </div>\n  <div class=\"sky-status-indicator-message-wrapper\">\n    <span *ngIf=\"descriptionComputed\" class=\"sky-screen-reader-only\">\n      {{ descriptionComputed }}\n    </span>\n    <span skyId #message=\"skyId\" class=\"sky-status-indicator-message\" skyTrim\n      ><ng-content /></span\n    ><span class=\"sky-control-help-container\"\n      ><sky-help-inline\n        *ngIf=\"helpPopoverContent || helpKey; else helpContent\"\n        [labelledBy]=\"message.id\"\n        [helpKey]=\"helpKey\"\n        [popoverTitle]=\"helpPopoverTitle\"\n        [popoverContent]=\"helpPopoverContent\"\n    /></span>\n  </div>\n</div>\n", styles: [".sky-status-indicator{align-items:baseline;display:flex}.sky-status-indicator-icon{flex-shrink:1}.sky-status-indicator-icon-modern{display:none}.sky-status-indicator-icon-info{color:#00b4f1}.sky-status-indicator-icon-success{color:#72bf44}.sky-status-indicator-icon-warning{color:#fbb034}.sky-status-indicator-icon-danger{color:#ef4044}:host-context(.sky-theme-modern) .sky-status-indicator-icon:not(.sky-status-indicator-icon-danger){--sky-icon-stack-top-icon-color-override: #212327}:host-context(.sky-theme-modern) .sky-status-indicator-icon-default{display:none}:host-context(.sky-theme-modern) .sky-status-indicator-icon-modern{display:inline}.sky-theme-modern .sky-status-indicator-icon:not(.sky-status-indicator-icon-danger){--sky-icon-stack-top-icon-color-override: #212327}.sky-theme-modern .sky-status-indicator-icon-default{display:none}.sky-theme-modern .sky-status-indicator-icon-modern{display:inline}\n"] }]
        }], propDecorators: { indicatorType: [{
                type: Input
            }], descriptionType: [{
                type: Input
            }], customDescription: [{
                type: Input
            }], helpPopoverContent: [{
                type: Input
            }], helpPopoverTitle: [{
                type: Input
            }], helpKey: [{
                type: Input
            }] } });

class SkyStatusIndicatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyStatusIndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyStatusIndicatorModule, declarations: [SkyStatusIndicatorComponent], imports: [CommonModule,
            SkyHelpInlineModule$1,
            SkyIconModule,
            SkyIdModule,
            SkyIndicatorsResourcesModule,
            SkyTrimModule], exports: [SkyStatusIndicatorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyStatusIndicatorModule, imports: [CommonModule,
            SkyHelpInlineModule$1,
            SkyIconModule,
            SkyIdModule,
            SkyIndicatorsResourcesModule,
            SkyTrimModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyStatusIndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SkyStatusIndicatorComponent],
                    imports: [
                        CommonModule,
                        SkyHelpInlineModule$1,
                        SkyIconModule,
                        SkyIdModule,
                        SkyIndicatorsResourcesModule,
                        SkyTrimModule,
                    ],
                    exports: [SkyStatusIndicatorComponent],
                }]
        }] });

const CLASS_NAME = 'sky-highlight-mark';
const SPECIAL_CHAR_REGEX = /[-/\\^$*+?.()|[\]{}]/g;
function markNode(node, searchRegex) {
    // The search regular expression is reused across calls to markNode(), so reset
    // it so it searches from the start of the string each time.
    searchRegex.lastIndex = 0;
    const text = node.nodeValue;
    if (text) {
        const match = searchRegex.exec(text);
        if (match) {
            // Split apart text node with mark tags in the middle on the search term.
            const matchIndex = match.index;
            const middle = node.splitText(matchIndex);
            middle.splitText(searchRegex.lastIndex - matchIndex);
            const middleClone = middle.cloneNode(true);
            const markNode = document.createElement('mark');
            markNode.className = CLASS_NAME;
            markNode.appendChild(middleClone);
            /* istanbul ignore else */
            if (middle.parentNode) {
                middle.parentNode.replaceChild(markNode, middle);
            }
            return 1;
        }
    }
    return 0;
}
function markTextNodes(node, searchRegex) {
    if (node.nodeType === 3) {
        return markNode(node, searchRegex);
    }
    else if (node.nodeType === 1 && node.childNodes) {
        for (let i = 0; i < node.childNodes.length; i++) {
            const childNode = node.childNodes[i];
            i += markTextNodes(childNode, searchRegex);
        }
    }
    return 0;
}
function removeHighlight(el) {
    const matchedElements = Array.from(el.nativeElement.querySelectorAll(`mark.${CLASS_NAME}`));
    if (matchedElements) {
        for (const node of matchedElements) {
            const parentNode = node.parentNode;
            if (parentNode && node.firstChild) {
                parentNode.replaceChild(node.firstChild, node);
                parentNode.normalize();
            }
        }
    }
}
function createSearchRegex(searchTerms) {
    let searchRegex;
    if (searchTerms.length > 0) {
        // Escape all the special regular expression characters by adding a
        // preceding '\' to each match.
        searchTerms = searchTerms.map((searchTerm) => searchTerm.replace(SPECIAL_CHAR_REGEX, '\\$&'));
        searchRegex = new RegExp(searchTerms.join('|'), 'gi');
    }
    return searchRegex;
}
// Need to add the following to classes which contain static methods.
// See: https://github.com/ng-packagr/ng-packagr/issues/641
// @dynamic
/**
 * Highlights all matching text within the current DOM element.
 */
class SkyTextHighlightDirective {
    /**
     * The text to highlight.
     */
    set skyHighlight(value) {
        value = value || [];
        if (Array.isArray(value)) {
            this.#searchTerms = value.filter((item) => !!item);
            // Reorder strings by their length in descending order to avoid missing matches
            // that contain substrings of other matches.
            this.#searchTerms.sort(function (a, b) {
                return b.length - a.length;
            });
        }
        else {
            this.#searchTerms = [value];
        }
    }
    #existingHighlight = false;
    #observer;
    #searchTerms = [];
    #el = inject(ElementRef);
    #observerSvc = inject(SkyMutationObserverService);
    ngOnChanges(changes) {
        if (changes['skyHighlight'] && !changes['skyHighlight'].firstChange) {
            this.#highlight();
        }
    }
    ngAfterViewInit() {
        this.#observer = this.#observerSvc.create(() => {
            this.#highlight();
        });
        this.#highlight();
    }
    ngOnDestroy() {
        this.#disconnectObserver();
    }
    #disconnectObserver() {
        if (this.#observer) {
            this.#observer.disconnect();
        }
    }
    #highlight() {
        this.#disconnectObserver();
        if (this.#existingHighlight) {
            removeHighlight(this.#el);
        }
        const node = this.#el.nativeElement;
        if (node) {
            const searchRegex = createSearchRegex(this.#searchTerms);
            // mark all matched text in the DOM
            if (searchRegex) {
                markTextNodes(node, searchRegex);
                this.#existingHighlight = true;
            }
        }
        this.#observeDom();
    }
    #observeDom() {
        if (this.#observer) {
            const config = {
                attributes: false,
                childList: true,
                characterData: true,
                subtree: true,
            };
            this.#observer.observe(this.#el.nativeElement, config);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTextHighlightDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.4", type: SkyTextHighlightDirective, isStandalone: true, selector: "[skyHighlight]", inputs: { skyHighlight: "skyHighlight" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTextHighlightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[skyHighlight]',
                    standalone: true,
                }]
        }], propDecorators: { skyHighlight: [{
                type: Input
            }] } });

class SkyTextHighlightModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTextHighlightModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyTextHighlightModule, imports: [SkyTextHighlightDirective], exports: [SkyTextHighlightDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTextHighlightModule, providers: [SkyMutationObserverService] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTextHighlightModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [SkyTextHighlightDirective],
                    exports: [SkyTextHighlightDirective],
                    providers: [SkyMutationObserverService],
                }]
        }] });

class SkyTokenComponent {
    constructor() {
        /**
         * Fires when users click the close button.
         */
        this.dismiss = new EventEmitter();
        /**
         * Fires when users place focus on the token by navigating to it with the `Tab` key.
         */
        this.tokenFocus = new EventEmitter();
        this.isFocused = false;
        this.tokenActive = false;
        this.closeActive = false;
        this.tabIndex = 0;
        this.#elementRef = inject(ElementRef);
        this.#liveAnnouncerSvc = inject(SkyLiveAnnouncerService);
        this.#resourcesSvc = inject(SkyLibResourcesService);
        this.#_disabled = false;
        this.#_dismissible = true;
    }
    /**
     * Whether to disable the token to prevent users from selecting it, dismissing it,
     * or navigating to it with the arrow keys. When the token is disabled,
     * users can still place focus on it using the `Tab` key.
     * @default false
     */
    set disabled(value) {
        this.#_disabled = !!value;
    }
    get disabled() {
        return this.#_disabled;
    }
    /**
     * Whether users can remove the token from the list by selecting the close button.
     * @default true
     */
    set dismissible(value) {
        this.#_dismissible = value !== false;
    }
    get dismissible() {
        return this.#_dismissible;
    }
    /**
     * Whether users can place focus on the token using the `Tab`. This does not
     * affect the ability to select the token, dismiss it, or navigate to it with the arrow keys.
     * @default true
     */
    set focusable(value) {
        this.tabIndex = value !== false ? 0 : -1;
    }
    #elementRef;
    #liveAnnouncerSvc;
    #resourcesSvc;
    #_disabled;
    #_dismissible;
    onFocusIn() {
        if (!this.isFocused) {
            this.tokenFocus.emit();
            this.isFocused = true;
        }
    }
    onFocusOut(event) {
        this.isFocused = this.#elementRef.nativeElement.contains(event.relatedTarget);
    }
    dismissToken(event) {
        event.stopPropagation();
        this.#announceState('skyux_tokens_token_dismissed', this.actionButtonRef?.nativeElement.textContent.trim());
        this.dismiss.emit();
    }
    focusElement() {
        this.actionButtonRef?.nativeElement.focus();
    }
    setTokenActive(tokenActive) {
        this.tokenActive = tokenActive;
    }
    setCloseActive(closeActive) {
        this.closeActive = closeActive;
    }
    #announceState(resourceString, ...args) {
        this.#resourcesSvc
            .getString(resourceString, ...args)
            .pipe(take(1))
            .subscribe((internationalizedString) => {
            this.#liveAnnouncerSvc.announce(internationalizedString);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTokenComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyTokenComponent, selector: "sky-token", inputs: { disabled: "disabled", ariaLabel: "ariaLabel", dismissible: "dismissible", focusable: "focusable", role: "role" }, outputs: { dismiss: "dismiss", tokenFocus: "tokenFocus" }, viewQueries: [{ propertyName: "actionButtonRef", first: true, predicate: ["actionButton"], descendants: true, read: ElementRef, static: true }], ngImport: i0, template: "<div\n  class=\"sky-token sky-btn sky-btn-default\"\n  [attr.role]=\"role\"\n  [ngClass]=\"{\n    'sky-btn-disabled': disabled,\n    'sky-token-disabled': disabled,\n    'sky-token-dismissible': dismissible,\n    'sky-token-active': tokenActive && !closeActive,\n    'sky-token-focused': isFocused\n  }\"\n  (document:mouseup)=\"setTokenActive(false)\"\n  (focusin)=\"onFocusIn()\"\n  (focusout)=\"onFocusOut($event)\"\n  (mousedown)=\"setTokenActive(true)\"\n>\n  <span\n    [attr.role]=\"role === 'row' ? 'gridcell' : undefined\"\n    class=\"sky-token-cell\"\n  >\n    <button\n      class=\"sky-btn sky-btn-default sky-token-btn sky-token-btn-action\"\n      type=\"button\"\n      [attr.tabindex]=\"tabIndex\"\n      [disabled]=\"disabled\"\n      [ngClass]=\"{\n        'sky-btn-disabled': disabled\n      }\"\n      #actionButton=\"skyId\"\n      skyId\n    >\n      <ng-content />\n    </button>\n  </span>\n  <span\n    *ngIf=\"dismissible\"\n    class=\"sky-token-cell\"\n    [attr.role]=\"role === 'row' ? 'gridcell' : undefined\"\n  >\n    <button\n      class=\"sky-btn sky-token-btn sky-token-btn-close\"\n      type=\"button\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.aria-labelledby]=\"\n        !ariaLabel\n          ? screenReaderLabelDismiss.id + ' ' + actionButton.id\n          : undefined\n      \"\n      [attr.tabindex]=\"tabIndex\"\n      [attr.title]=\"\n        ariaLabel || ('skyux_tokens_dismiss_button_title' | skyLibResources)\n      \"\n      [disabled]=\"disabled\"\n      [ngClass]=\"{\n        'sky-btn-disabled': disabled,\n        'sky-token-btn-close-active': closeActive\n      }\"\n      (click)=\"dismissToken($event)\"\n      (document:mouseup)=\"setCloseActive(false)\"\n      (mousedown)=\"setCloseActive(true)\"\n    >\n      <sky-icon class=\"sky-token-btn-close-icon\" icon=\"close\" />\n    </button>\n  </span>\n</div>\n<span\n  skyScreenReaderLabel\n  [createLabel]=\"dismissible && !ariaLabel\"\n  skyId\n  #screenReaderLabelDismiss=\"skyId\"\n>\n  {{ 'skyux_tokens_dismiss_button_default_label' | skyLibResources }}\n</span>\n", styles: [".sky-token{background-color:#c1e8fb;border:1px solid #00b4f1;padding:0;display:inline-block}.sky-token:hover,.sky-token.sky-token-focused{background-color:#91d6f8;border-color:#008ebe;cursor:pointer}.sky-token.sky-token-focused{box-shadow:0 0 8px #00b4f199;border:1px solid var(--sky-highlight-color-info);outline:none}.sky-token.sky-btn-disabled .sky-btn-disabled{opacity:1}.sky-btn-disabled{cursor:default;-webkit-user-select:none;user-select:none}.sky-token-btn{background-color:transparent;border:0;padding:2px 8px}.sky-token-btn-action:focus-visible{outline:none}.sky-token-btn-close{margin-left:-2px;opacity:.9}.sky-token-btn-close:hover,.sky-token-btn-close:focus-visible{opacity:1}.sky-token-dismissible .sky-token-btn-action{padding-right:0}:host-context(.sky-theme-modern) .sky-token{align-items:center;display:inline-flex;font-size:14px}:host-context(.sky-theme-modern) .sky-token:not(.sky-btn-disabled){border:none;box-shadow:inset 0 0 0 1px #81d4f7;background-color:#ebfbff}:host-context(.sky-theme-modern) .sky-token.sky-token-dismissible{padding-right:1px}:host-context(.sky-theme-modern) .sky-token.sky-token-dismissible .sky-token-btn-action{padding-right:0}:host-context(.sky-theme-modern) .sky-token:hover:not(:active){border:none;box-shadow:inset 0 0 0 1px #1870b8}:host-context(.sky-theme-modern) .sky-token.sky-token-active{border:none;box-shadow:inset 0 0 0 2px #1870b8}:host-context(.sky-theme-modern) .sky-token.sky-token-focused:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 3px #0000004d}:host-context(.sky-theme-modern) .sky-token.sky-token-focused,:host-context(.sky-theme-modern) .sky-token:hover{background-color:#ebfbff}:host-context(.sky-theme-modern) .sky-token-btn{padding:1px 5px;border:0;box-shadow:none;background-color:transparent}:host-context(.sky-theme-modern) .sky-token-btn.sky-btn-disabled{color:#212327}:host-context(.sky-theme-modern) .sky-token-btn-action{font-size:14px}:host-context(.sky-theme-modern) .sky-token-btn-close{align-items:center;border-radius:5px;display:flex;height:20px;margin-left:5px;width:20px;padding:0}:host-context(.sky-theme-modern) .sky-token-btn-close:hover{border:none;box-shadow:inset 0 0 0 1px transparent}:host-context(.sky-theme-modern) .sky-token-btn-close.sky-token-btn-close-active{border:none;box-shadow:inset 0 0 0 2px #1870b8}:host-context(.sky-theme-modern) .sky-token-btn-close:focus-visible{outline:none}:host-context(.sky-theme-modern) .sky-token-btn-close:focus-visible:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 3px #0000004d}:host-context(.sky-theme-modern) .sky-token-btn-close-icon{width:100%}.sky-theme-modern .sky-token{align-items:center;display:inline-flex;font-size:14px}.sky-theme-modern .sky-token:not(.sky-btn-disabled){border:none;box-shadow:inset 0 0 0 1px #81d4f7;background-color:#ebfbff}.sky-theme-modern .sky-token.sky-token-dismissible{padding-right:1px}.sky-theme-modern .sky-token.sky-token-dismissible .sky-token-btn-action{padding-right:0}.sky-theme-modern .sky-token:hover:not(:active){border:none;box-shadow:inset 0 0 0 1px #1870b8}.sky-theme-modern .sky-token.sky-token-active{border:none;box-shadow:inset 0 0 0 2px #1870b8}.sky-theme-modern .sky-token.sky-token-focused:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 3px #0000004d}.sky-theme-modern .sky-token.sky-token-focused,.sky-theme-modern .sky-token:hover{background-color:#ebfbff}.sky-theme-modern .sky-token-btn{padding:1px 5px;border:0;box-shadow:none;background-color:transparent}.sky-theme-modern .sky-token-btn.sky-btn-disabled{color:#212327}.sky-theme-modern .sky-token-btn-action{font-size:14px}.sky-theme-modern .sky-token-btn-close{align-items:center;border-radius:5px;display:flex;height:20px;margin-left:5px;width:20px;padding:0}.sky-theme-modern .sky-token-btn-close:hover{border:none;box-shadow:inset 0 0 0 1px transparent}.sky-theme-modern .sky-token-btn-close.sky-token-btn-close-active{border:none;box-shadow:inset 0 0 0 2px #1870b8}.sky-theme-modern .sky-token-btn-close:focus-visible{outline:none}.sky-theme-modern .sky-token-btn-close:focus-visible:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 3px #0000004d}.sky-theme-modern .sky-token-btn-close-icon{width:100%}:host-context(.sky-theme-modern.sky-theme-mode-dark) .sky-token{background-color:#c1e8fb}:host-context(.sky-theme-modern.sky-theme-mode-dark) .sky-token,:host-context(.sky-theme-modern.sky-theme-mode-dark) .sky-token-btn-close{color:#212327}.sky-theme-modern.sky-theme-mode-dark .sky-token{background-color:#c1e8fb}.sky-theme-modern.sky-theme-mode-dark .sky-token,.sky-theme-modern.sky-theme-mode-dark .sky-token-btn-close{color:#212327}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.λ1, selector: "sky-icon", inputs: ["icon", "iconName", "iconType", "size", "fixedWidth", "variant"] }, { kind: "directive", type: i3$1.λ2, selector: "[skyId]", exportAs: ["skyId"] }, { kind: "directive", type: i3$1.SkyScreenReaderLabelDirective, selector: "[skyScreenReaderLabel]", inputs: ["createLabel"] }, { kind: "pipe", type: i4.SkyLibResourcesPipe, name: "skyLibResources" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTokenComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-token', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"sky-token sky-btn sky-btn-default\"\n  [attr.role]=\"role\"\n  [ngClass]=\"{\n    'sky-btn-disabled': disabled,\n    'sky-token-disabled': disabled,\n    'sky-token-dismissible': dismissible,\n    'sky-token-active': tokenActive && !closeActive,\n    'sky-token-focused': isFocused\n  }\"\n  (document:mouseup)=\"setTokenActive(false)\"\n  (focusin)=\"onFocusIn()\"\n  (focusout)=\"onFocusOut($event)\"\n  (mousedown)=\"setTokenActive(true)\"\n>\n  <span\n    [attr.role]=\"role === 'row' ? 'gridcell' : undefined\"\n    class=\"sky-token-cell\"\n  >\n    <button\n      class=\"sky-btn sky-btn-default sky-token-btn sky-token-btn-action\"\n      type=\"button\"\n      [attr.tabindex]=\"tabIndex\"\n      [disabled]=\"disabled\"\n      [ngClass]=\"{\n        'sky-btn-disabled': disabled\n      }\"\n      #actionButton=\"skyId\"\n      skyId\n    >\n      <ng-content />\n    </button>\n  </span>\n  <span\n    *ngIf=\"dismissible\"\n    class=\"sky-token-cell\"\n    [attr.role]=\"role === 'row' ? 'gridcell' : undefined\"\n  >\n    <button\n      class=\"sky-btn sky-token-btn sky-token-btn-close\"\n      type=\"button\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.aria-labelledby]=\"\n        !ariaLabel\n          ? screenReaderLabelDismiss.id + ' ' + actionButton.id\n          : undefined\n      \"\n      [attr.tabindex]=\"tabIndex\"\n      [attr.title]=\"\n        ariaLabel || ('skyux_tokens_dismiss_button_title' | skyLibResources)\n      \"\n      [disabled]=\"disabled\"\n      [ngClass]=\"{\n        'sky-btn-disabled': disabled,\n        'sky-token-btn-close-active': closeActive\n      }\"\n      (click)=\"dismissToken($event)\"\n      (document:mouseup)=\"setCloseActive(false)\"\n      (mousedown)=\"setCloseActive(true)\"\n    >\n      <sky-icon class=\"sky-token-btn-close-icon\" icon=\"close\" />\n    </button>\n  </span>\n</div>\n<span\n  skyScreenReaderLabel\n  [createLabel]=\"dismissible && !ariaLabel\"\n  skyId\n  #screenReaderLabelDismiss=\"skyId\"\n>\n  {{ 'skyux_tokens_dismiss_button_default_label' | skyLibResources }}\n</span>\n", styles: [".sky-token{background-color:#c1e8fb;border:1px solid #00b4f1;padding:0;display:inline-block}.sky-token:hover,.sky-token.sky-token-focused{background-color:#91d6f8;border-color:#008ebe;cursor:pointer}.sky-token.sky-token-focused{box-shadow:0 0 8px #00b4f199;border:1px solid var(--sky-highlight-color-info);outline:none}.sky-token.sky-btn-disabled .sky-btn-disabled{opacity:1}.sky-btn-disabled{cursor:default;-webkit-user-select:none;user-select:none}.sky-token-btn{background-color:transparent;border:0;padding:2px 8px}.sky-token-btn-action:focus-visible{outline:none}.sky-token-btn-close{margin-left:-2px;opacity:.9}.sky-token-btn-close:hover,.sky-token-btn-close:focus-visible{opacity:1}.sky-token-dismissible .sky-token-btn-action{padding-right:0}:host-context(.sky-theme-modern) .sky-token{align-items:center;display:inline-flex;font-size:14px}:host-context(.sky-theme-modern) .sky-token:not(.sky-btn-disabled){border:none;box-shadow:inset 0 0 0 1px #81d4f7;background-color:#ebfbff}:host-context(.sky-theme-modern) .sky-token.sky-token-dismissible{padding-right:1px}:host-context(.sky-theme-modern) .sky-token.sky-token-dismissible .sky-token-btn-action{padding-right:0}:host-context(.sky-theme-modern) .sky-token:hover:not(:active){border:none;box-shadow:inset 0 0 0 1px #1870b8}:host-context(.sky-theme-modern) .sky-token.sky-token-active{border:none;box-shadow:inset 0 0 0 2px #1870b8}:host-context(.sky-theme-modern) .sky-token.sky-token-focused:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 3px #0000004d}:host-context(.sky-theme-modern) .sky-token.sky-token-focused,:host-context(.sky-theme-modern) .sky-token:hover{background-color:#ebfbff}:host-context(.sky-theme-modern) .sky-token-btn{padding:1px 5px;border:0;box-shadow:none;background-color:transparent}:host-context(.sky-theme-modern) .sky-token-btn.sky-btn-disabled{color:#212327}:host-context(.sky-theme-modern) .sky-token-btn-action{font-size:14px}:host-context(.sky-theme-modern) .sky-token-btn-close{align-items:center;border-radius:5px;display:flex;height:20px;margin-left:5px;width:20px;padding:0}:host-context(.sky-theme-modern) .sky-token-btn-close:hover{border:none;box-shadow:inset 0 0 0 1px transparent}:host-context(.sky-theme-modern) .sky-token-btn-close.sky-token-btn-close-active{border:none;box-shadow:inset 0 0 0 2px #1870b8}:host-context(.sky-theme-modern) .sky-token-btn-close:focus-visible{outline:none}:host-context(.sky-theme-modern) .sky-token-btn-close:focus-visible:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 3px #0000004d}:host-context(.sky-theme-modern) .sky-token-btn-close-icon{width:100%}.sky-theme-modern .sky-token{align-items:center;display:inline-flex;font-size:14px}.sky-theme-modern .sky-token:not(.sky-btn-disabled){border:none;box-shadow:inset 0 0 0 1px #81d4f7;background-color:#ebfbff}.sky-theme-modern .sky-token.sky-token-dismissible{padding-right:1px}.sky-theme-modern .sky-token.sky-token-dismissible .sky-token-btn-action{padding-right:0}.sky-theme-modern .sky-token:hover:not(:active){border:none;box-shadow:inset 0 0 0 1px #1870b8}.sky-theme-modern .sky-token.sky-token-active{border:none;box-shadow:inset 0 0 0 2px #1870b8}.sky-theme-modern .sky-token.sky-token-focused:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 3px #0000004d}.sky-theme-modern .sky-token.sky-token-focused,.sky-theme-modern .sky-token:hover{background-color:#ebfbff}.sky-theme-modern .sky-token-btn{padding:1px 5px;border:0;box-shadow:none;background-color:transparent}.sky-theme-modern .sky-token-btn.sky-btn-disabled{color:#212327}.sky-theme-modern .sky-token-btn-action{font-size:14px}.sky-theme-modern .sky-token-btn-close{align-items:center;border-radius:5px;display:flex;height:20px;margin-left:5px;width:20px;padding:0}.sky-theme-modern .sky-token-btn-close:hover{border:none;box-shadow:inset 0 0 0 1px transparent}.sky-theme-modern .sky-token-btn-close.sky-token-btn-close-active{border:none;box-shadow:inset 0 0 0 2px #1870b8}.sky-theme-modern .sky-token-btn-close:focus-visible{outline:none}.sky-theme-modern .sky-token-btn-close:focus-visible:not(:active){border:none;box-shadow:inset 0 0 0 2px #1870b8,0 1px 3px #0000004d}.sky-theme-modern .sky-token-btn-close-icon{width:100%}:host-context(.sky-theme-modern.sky-theme-mode-dark) .sky-token{background-color:#c1e8fb}:host-context(.sky-theme-modern.sky-theme-mode-dark) .sky-token,:host-context(.sky-theme-modern.sky-theme-mode-dark) .sky-token-btn-close{color:#212327}.sky-theme-modern.sky-theme-mode-dark .sky-token{background-color:#c1e8fb}.sky-theme-modern.sky-theme-mode-dark .sky-token,.sky-theme-modern.sky-theme-mode-dark .sky-token-btn-close{color:#212327}\n"] }]
        }], propDecorators: { disabled: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], dismissible: [{
                type: Input
            }], focusable: [{
                type: Input
            }], role: [{
                type: Input
            }], dismiss: [{
                type: Output
            }], tokenFocus: [{
                type: Output
            }], actionButtonRef: [{
                type: ViewChild,
                args: ['actionButton', { read: ElementRef, static: true }]
            }] } });

var SkyTokensMessageType;
(function (SkyTokensMessageType) {
    /**
     * Places focus on the last token in the list.
     */
    SkyTokensMessageType[SkyTokensMessageType["FocusLastToken"] = 0] = "FocusLastToken";
    /**
     * Places focus on the token that is currently selected.
     */
    SkyTokensMessageType[SkyTokensMessageType["FocusActiveToken"] = 1] = "FocusActiveToken";
    /**
     * Places focus on the token before the currently selected token.
     */
    SkyTokensMessageType[SkyTokensMessageType["FocusPreviousToken"] = 2] = "FocusPreviousToken";
    /**
     * Places focus on the token after the currently selected token.
     */
    SkyTokensMessageType[SkyTokensMessageType["FocusNextToken"] = 3] = "FocusNextToken";
    /**
     * Removes the token that is currently selected from the list of tokens.
     */
    SkyTokensMessageType[SkyTokensMessageType["RemoveActiveToken"] = 4] = "RemoveActiveToken";
})(SkyTokensMessageType || (SkyTokensMessageType = {}));

const DISPLAY_WITH_DEFAULT = 'name';
/**
 * Creates a container that enables navigation between tokens using keyboard arrow keys.
 * This is useful when combined with other components where the <kbd>Tab</kbd> key is
 * reserved for other functions, such as the SKY UX Lookup component.
 */
class SkyTokensComponent {
    /**
     * Whether to disable the tokens list to prevent users from selecting tokens,
     * dismissing tokens, or navigating through the list with the arrow keys. When the tokens list
     * is disabled, users can still place focus on items in the list using the `Tab` key.
     * @default false
     */
    set disabled(value) {
        this.#_disabled = !!value;
    }
    get disabled() {
        return this.#_disabled;
    }
    /**
     * Whether users can remove a token from the list by selecting a token's close button.
     * @default true
     */
    set dismissible(value) {
        this.#_dismissible = value !== false;
    }
    get dismissible() {
        return this.#_dismissible;
    }
    /**
     * The token property to display for each item in the tokens list.
     * @default "name"
     */
    set displayWith(value) {
        this.#_displayWith = value || DISPLAY_WITH_DEFAULT;
    }
    get displayWith() {
        return this.#_displayWith;
    }
    /**
     * Whether users can place focus on tokens in the list using the `Tab` key.
     * This does not affect the ability of users to select tokens, dismiss tokens,
     * or navigate through the list with the arrow keys.
     * @default true
     */
    set focusable(value) {
        this.#_focusable = value !== false;
    }
    get focusable() {
        return this.#_focusable;
    }
    /**
     * The array of tokens to include in the list.
     */
    set tokens(value) {
        this.#_tokens = value || [];
        // The previous behavior was to set `this._tokens = value`, then emit `this._tokens`,
        // which would emit `undefined` instead of a default value of `[]` returned by the
        // get accessor when set to `undefined`. Emitting `value` instead of `this.#_tokensOrDefault`
        // preserves that behavior.
        this.tokensChange.emit(value);
    }
    get tokens() {
        return this.#_tokens;
    }
    /**
     * The observable of `SkyTokensMessage` that can place focus on a
     * particular token or remove the active token from the list.
     */
    set messageStream(value) {
        this.#_messageStream = value || new Subject();
        this.#initMessageStream();
    }
    get messageStream() {
        return this.#_messageStream;
    }
    get activeIndex() {
        return this.#_activeIndex;
    }
    set activeIndex(value) {
        if (value >= this.#_tokens.length) {
            value = this.#_tokens.length - 1;
            this.focusIndexOverRange.emit();
        }
        if (value < 0) {
            value = 0;
            this.focusIndexUnderRange.emit();
        }
        this.#_activeIndex = value || 0;
    }
    #_disabled;
    #_dismissible;
    #_focusable;
    #_tokens;
    #_displayWith;
    #messageStreamSub;
    #ngUnsubscribe;
    #changeDetector;
    #_activeIndex;
    #_messageStream;
    constructor() {
        /**
         * Fires when users navigate through the tokens list with the `Tab` key
         * and attempt to move past the final token in the list.
         */
        this.focusIndexOverRange = new EventEmitter();
        /**
         * Fires when users navigate through the tokens list with the `Tab` key
         * and attempt to move before the first token in the list.
         */
        this.focusIndexUnderRange = new EventEmitter();
        /**
         * Fires when users select a token in the list. This event emits the selected token.
         */
        this.tokenSelected = new EventEmitter();
        /**
         * Fires when the tokens in the list change.
         * This event emits an array of the tokens in the updated list.
         */
        this.tokensChange = new EventEmitter();
        /**
         * Fires when all animations on the tokens are complete.
         * @internal
         */
        this.tokensRendered = new EventEmitter();
        this.#_disabled = false;
        this.#_dismissible = true;
        this.#_focusable = true;
        this.#_tokens = [];
        this.#_displayWith = DISPLAY_WITH_DEFAULT;
        this.#ngUnsubscribe = new Subject();
        this.#changeDetector = inject(ChangeDetectorRef);
        this.#_activeIndex = 0;
        this.#_messageStream = new Subject();
        this.#initMessageStream();
        // Angular calls the trackBy function without applying the component instance's scope.
        // Use a fat-arrow function so the current component instance's trackWith property can
        // be referenced.
        this.trackTokenFn = (_index, item) => {
            if (this.trackWith) {
                return item.value[this.trackWith];
            }
            return item;
        };
    }
    ngOnDestroy() {
        this.#ngUnsubscribe.next();
        this.#ngUnsubscribe.complete();
    }
    onTokenClick(token) {
        if (this.disabled) {
            return;
        }
        this.#notifyTokenSelected(token);
    }
    animationDone() {
        this.tokensRendered.emit();
    }
    onTokenKeyDown(event) {
        if (!this.disabled) {
            switch (event.key) {
                case 'Left':
                case 'ArrowLeft':
                    this.#_messageStream.next({
                        type: SkyTokensMessageType.FocusPreviousToken,
                    });
                    event.preventDefault();
                    break;
                case 'Right':
                case 'ArrowRight':
                    this.#_messageStream.next({
                        type: SkyTokensMessageType.FocusNextToken,
                    });
                    event.preventDefault();
                    break;
            }
        }
    }
    selectToken(token) {
        if (!this.disabled) {
            this.#notifyTokenSelected(token);
        }
    }
    removeToken(token) {
        this.tokens = this.tokens.filter((t) => t !== token);
        this.#changeDetector.detectChanges();
    }
    #focusPreviousToken() {
        this.activeIndex--;
        this.#focusActiveToken();
    }
    #focusNextToken() {
        this.activeIndex++;
        this.#focusActiveToken();
    }
    #focusLastToken() {
        if (this.tokenComponents) {
            this.activeIndex = this.tokenComponents.length - 1;
            this.#focusActiveToken();
        }
    }
    #focusActiveToken() {
        if (this.tokenComponents) {
            const tokenComponent = this.tokenComponents.find((_comp, i) => {
                return this.activeIndex === i;
            });
            if (tokenComponent) {
                tokenComponent.focusElement();
            }
        }
    }
    #removeActiveToken() {
        const token = this.tokens[this.activeIndex];
        if (token) {
            this.removeToken(token);
        }
    }
    #initMessageStream() {
        if (this.#messageStreamSub) {
            this.#messageStreamSub.unsubscribe();
        }
        this.#messageStreamSub = this.messageStream
            .pipe(takeUntil(this.#ngUnsubscribe))
            .subscribe((message) => {
            switch (message.type) {
                case SkyTokensMessageType.FocusLastToken:
                    this.#focusLastToken();
                    break;
                case SkyTokensMessageType.FocusActiveToken:
                    this.#focusActiveToken();
                    break;
                case SkyTokensMessageType.FocusPreviousToken:
                    this.#focusPreviousToken();
                    break;
                case SkyTokensMessageType.FocusNextToken:
                    this.#focusNextToken();
                    break;
                case SkyTokensMessageType.RemoveActiveToken:
                    this.#removeActiveToken();
                    break;
            }
        });
    }
    #notifyTokenSelected(token) {
        this.tokenSelected.emit({
            token,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTokensComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyTokensComponent, selector: "sky-tokens", inputs: { disabled: "disabled", dismissible: "dismissible", displayWith: "displayWith", trackWith: "trackWith", focusable: "focusable", tokens: "tokens", messageStream: "messageStream" }, outputs: { focusIndexOverRange: "focusIndexOverRange", focusIndexUnderRange: "focusIndexUnderRange", tokenSelected: "tokenSelected", tokensChange: "tokensChange", tokensRendered: "tokensRendered" }, viewQueries: [{ propertyName: "tokenComponents", predicate: SkyTokenComponent, descendants: true }], ngImport: i0, template: "<div\n  class=\"sky-tokens\"\n  [@blockAnimationOnLoad]\n  [attr.role]=\"tokens.length ? 'grid' : null\"\n>\n  <!--\n      The role must use square brackets otherwise Angular sets the native 'role'\n      attribute as well as the input attribute of the token, which fails accessibility rules.\n    -->\n  <sky-token\n    *ngFor=\"let token of tokens; let i = index; trackBy: trackTokenFn\"\n    [@.disabled]=\"!trackWith\"\n    [@dismiss]\n    [disabled]=\"disabled\"\n    [dismissible]=\"dismissible\"\n    [focusable]=\"focusable\"\n    [role]=\"'row'\"\n    (@dismiss.done)=\"animationDone()\"\n    (dismiss)=\"removeToken(token)\"\n    (click)=\"onTokenClick(token)\"\n    (keydown)=\"onTokenKeyDown($event)\"\n    (keyup.enter)=\"selectToken(token); $event.preventDefault()\"\n    (tokenFocus)=\"activeIndex = i\"\n  >\n    {{ token.value[displayWith] }}\n  </sky-token>\n  <div class=\"sky-tokens-content\" [attr.role]=\"tokens.length ? 'row' : null\">\n    <div [attr.role]=\"tokens.length ? 'gridcell' : null\">\n      <ng-content />\n    </div>\n  </div>\n</div>\n", styles: ["@charset \"UTF-8\";.sky-tokens{display:flex;flex-wrap:wrap;align-items:baseline;margin:-2px}.sky-tokens .sky-tokens-content,.sky-tokens ::ng-deep sky-token{flex:0 0 auto;display:inline-flex;padding:2px}.sky-tokens .sky-tokens-content{flex-grow:1;flex-basis:0px}.sky-tokens .sky-tokens-content>div{display:contents}.sky-tokens .sky-tokens-content>div:before{content:\"\\200b\"}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: SkyTokenComponent, selector: "sky-token", inputs: ["disabled", "ariaLabel", "dismissible", "focusable", "role"], outputs: ["dismiss", "tokenFocus"] }], animations: [
            trigger('blockAnimationOnLoad', [transition(':enter', [])]),
            trigger('dismiss', [
                transition(':enter', [
                    style({
                        opacity: 0,
                        width: 0,
                    }),
                    animate('150ms ease-in', style({
                        opacity: 1,
                        width: '*',
                    })),
                ]),
                transition(':leave', [
                    animate('150ms ease-in', style({
                        opacity: 0,
                        width: 0,
                    })),
                ]),
            ]),
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTokensComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sky-tokens', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('blockAnimationOnLoad', [transition(':enter', [])]),
                        trigger('dismiss', [
                            transition(':enter', [
                                style({
                                    opacity: 0,
                                    width: 0,
                                }),
                                animate('150ms ease-in', style({
                                    opacity: 1,
                                    width: '*',
                                })),
                            ]),
                            transition(':leave', [
                                animate('150ms ease-in', style({
                                    opacity: 0,
                                    width: 0,
                                })),
                            ]),
                        ]),
                    ], template: "<div\n  class=\"sky-tokens\"\n  [@blockAnimationOnLoad]\n  [attr.role]=\"tokens.length ? 'grid' : null\"\n>\n  <!--\n      The role must use square brackets otherwise Angular sets the native 'role'\n      attribute as well as the input attribute of the token, which fails accessibility rules.\n    -->\n  <sky-token\n    *ngFor=\"let token of tokens; let i = index; trackBy: trackTokenFn\"\n    [@.disabled]=\"!trackWith\"\n    [@dismiss]\n    [disabled]=\"disabled\"\n    [dismissible]=\"dismissible\"\n    [focusable]=\"focusable\"\n    [role]=\"'row'\"\n    (@dismiss.done)=\"animationDone()\"\n    (dismiss)=\"removeToken(token)\"\n    (click)=\"onTokenClick(token)\"\n    (keydown)=\"onTokenKeyDown($event)\"\n    (keyup.enter)=\"selectToken(token); $event.preventDefault()\"\n    (tokenFocus)=\"activeIndex = i\"\n  >\n    {{ token.value[displayWith] }}\n  </sky-token>\n  <div class=\"sky-tokens-content\" [attr.role]=\"tokens.length ? 'row' : null\">\n    <div [attr.role]=\"tokens.length ? 'gridcell' : null\">\n      <ng-content />\n    </div>\n  </div>\n</div>\n", styles: ["@charset \"UTF-8\";.sky-tokens{display:flex;flex-wrap:wrap;align-items:baseline;margin:-2px}.sky-tokens .sky-tokens-content,.sky-tokens ::ng-deep sky-token{flex:0 0 auto;display:inline-flex;padding:2px}.sky-tokens .sky-tokens-content{flex-grow:1;flex-basis:0px}.sky-tokens .sky-tokens-content>div{display:contents}.sky-tokens .sky-tokens-content>div:before{content:\"\\200b\"}\n"] }]
        }], ctorParameters: () => [], propDecorators: { disabled: [{
                type: Input
            }], dismissible: [{
                type: Input
            }], displayWith: [{
                type: Input
            }], trackWith: [{
                type: Input
            }], focusable: [{
                type: Input
            }], tokens: [{
                type: Input
            }], messageStream: [{
                type: Input
            }], focusIndexOverRange: [{
                type: Output
            }], focusIndexUnderRange: [{
                type: Output
            }], tokenSelected: [{
                type: Output
            }], tokensChange: [{
                type: Output
            }], tokensRendered: [{
                type: Output
            }], tokenComponents: [{
                type: ViewChildren,
                args: [SkyTokenComponent]
            }] } });

class SkyTokensModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTokensModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyTokensModule, declarations: [SkyTokenComponent, SkyTokensComponent], imports: [CommonModule,
            SkyIconModule,
            SkyIndicatorsResourcesModule,
            SkyIdModule,
            SkyScreenReaderLabelDirective], exports: [SkyTokenComponent, SkyTokensComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTokensModule, imports: [CommonModule,
            SkyIconModule,
            SkyIndicatorsResourcesModule,
            SkyIdModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyTokensModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SkyTokenComponent, SkyTokensComponent],
                    imports: [
                        CommonModule,
                        SkyIconModule,
                        SkyIndicatorsResourcesModule,
                        SkyIdModule,
                        SkyScreenReaderLabelDirective,
                    ],
                    exports: [SkyTokenComponent, SkyTokensComponent],
                }]
        }] });

var _a;
const busyElements = {};
// Need to add the following to classes which contain static methods.
// See: https://github.com/ng-packagr/ng-packagr/issues/641
/**
 * @internal
 * @dynamic
 */
class SkyWaitAdapterService {
    static { this.isPageWaitActive = false; }
    #focusableElements;
    #renderer;
    constructor(rendererFactory) {
        this.#renderer = rendererFactory.createRenderer(undefined, null);
    }
    ngOnDestroy() {
        this.#clearListeners();
    }
    setWaitBounds(waitEl) {
        this.#renderer.setStyle(waitEl.nativeElement.parentElement, 'position', 'relative');
    }
    removeWaitBounds(waitEl) {
        this.#renderer.removeStyle(waitEl.nativeElement.parentElement, 'position');
    }
    setBusyState(waitEl, isFullPage, isWaiting, isNonBlocking, waitComponentId) {
        const busyEl = isFullPage
            ? document.body
            : waitEl.nativeElement.parentElement;
        if (!isNonBlocking) {
            if (isWaiting) {
                let restoreFocusElement = undefined;
                let restoreFocusCheckElement = undefined;
                this.#renderer.setAttribute(busyEl, 'aria-busy', 'true');
                // Remove focus from page when full page blocking wait
                if (isFullPage || busyEl.contains(document.activeElement)) {
                    if (document.activeElement !== document.body) {
                        restoreFocusElement = document.activeElement;
                    }
                    this.#clearDocumentFocus();
                    restoreFocusCheckElement = document.activeElement;
                }
                if (isFullPage) {
                    _a.isPageWaitActive = true;
                    const endListenerFunc = this.#renderer.listen(document.body, 'keydown', (event) => {
                        /*istanbul ignore else */
                        if (event.key) {
                            /* istanbul ignore else */
                            if (event.key.toLowerCase() === 'tab') {
                                event.target.blur();
                                event.preventDefault();
                                event.stopPropagation();
                                event.stopImmediatePropagation();
                                this.#clearDocumentFocus();
                            }
                        }
                    });
                    if (waitComponentId) {
                        busyElements[waitComponentId] = {
                            listener: endListenerFunc,
                            busyEl: undefined,
                            restoreFocusElement,
                            restoreFocusCheckElement,
                        };
                    }
                }
                else {
                    const endListenerFunc = this.#renderer.listen(busyEl, 'focusin', (event) => {
                        /* istanbul ignore else */
                        if (!isNonBlocking) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();
                            if (_a.isPageWaitActive) {
                                this.#clearDocumentFocus();
                            }
                            else {
                                // Propagate tab navigation if attempted into waited element
                                const target = event.target;
                                if (target) {
                                    target.blur();
                                    this.#focusNextElement(target, this.#isShift(event));
                                }
                            }
                        }
                    });
                    if (waitComponentId) {
                        busyElements[waitComponentId] = {
                            listener: endListenerFunc,
                            busyEl,
                            restoreFocusElement,
                            restoreFocusCheckElement,
                        };
                    }
                }
            }
            else {
                this.#renderer.removeAttribute(busyEl, 'aria-busy');
                if (isFullPage) {
                    _a.isPageWaitActive = false;
                }
                if (waitComponentId && waitComponentId in busyElements) {
                    const busyElement = busyElements[waitComponentId];
                    busyElement.listener();
                    // If there is a restore focus element and the focus has not moved, restore focus.
                    if (busyElement.restoreFocusCheckElement === document.activeElement) {
                        busyElement.restoreFocusElement?.focus();
                    }
                    delete busyElements[waitComponentId];
                }
            }
        }
    }
    #focusNextElement(targetElement, shiftKey) {
        const focusable = this.#getFocusableElements();
        // If shift tab, go in the other direction
        const modifier = shiftKey ? -1 : 1;
        // Find the next navigable element that isn't waiting
        const startingIndex = focusable.indexOf(targetElement);
        let curIndex = startingIndex + modifier;
        while (focusable[curIndex] &&
            this.#isElementBusyOrHidden(focusable[curIndex])) {
            curIndex += modifier;
        }
        if (focusable[curIndex] &&
            !this.#isElementBusyOrHidden(focusable[curIndex])) {
            focusable[curIndex].focus();
        }
        else {
            // Try wrapping the navigation
            /* istanbul ignore next */
            /* sanity check */
            curIndex = modifier > 0 ? 0 : focusable.length - 1;
            while (curIndex !== startingIndex &&
                focusable[curIndex] &&
                this.#isElementBusyOrHidden(focusable[curIndex])) {
                /* istanbul ignore next */
                /* sanity check */
                curIndex += modifier;
            }
            /* istanbul ignore else */
            /* sanity check */
            if (focusable[curIndex] &&
                !this.#isElementBusyOrHidden(focusable[curIndex])) {
                focusable[curIndex].focus();
            }
            else {
                // No valid target, wipe focus
                this.#clearDocumentFocus();
            }
        }
        // clear focusableElements list
        this.#focusableElements = undefined;
    }
    #isShift(event) {
        // Determine if shift+tab was used based on element order
        const elements = this.#getFocusableElements().filter((elem) => !this.#isElementHidden(elem));
        const previousInd = elements.indexOf(event.relatedTarget);
        const currentInd = elements.indexOf(event.target);
        return (previousInd === currentInd + 1 ||
            (previousInd === 0 && currentInd === elements.length - 1) ||
            previousInd > currentInd ||
            !event.relatedTarget);
    }
    #isElementHidden(element) {
        const style = window.getComputedStyle(element);
        return style.display === 'none' || style.visibility === 'hidden';
    }
    #isElementBusyOrHidden(element) {
        if (this.#isElementHidden(element)) {
            return true;
        }
        for (const key of Object.keys(busyElements)) {
            const parentElement = busyElements[key].busyEl;
            if (parentElement && parentElement.contains(element)) {
                return true;
            }
        }
        return false;
    }
    #clearDocumentFocus() {
        const activeElement = document.activeElement;
        /* istanbul ignore else */
        if (activeElement) {
            activeElement.blur();
        }
        document.body.focus();
    }
    #getFocusableElements() {
        // Keep this cached so we can reduce queries
        if (this.#focusableElements) {
            return this.#focusableElements;
        }
        // Select all possible focusable elements
        const focusableElements = 'a[href], ' +
            'area[href], ' +
            "input:not([disabled]):not([tabindex='-1']), " +
            "button:not([disabled]):not([tabindex='-1']), " +
            "select:not([disabled]):not([tabindex='-1']), " +
            "textarea:not([disabled]):not([tabindex='-1']), " +
            'iframe, object, embed, ' +
            "*[tabindex]:not([tabindex='-1']), " +
            '*[contenteditable=true]';
        this.#focusableElements = Array.prototype.filter.call(document.body.querySelectorAll(focusableElements), (element) => {
            return (element.offsetWidth > 0 ||
                element.offsetHeight > 0 ||
                element === document.activeElement);
        });
        return this.#focusableElements;
    }
    #clearListeners() {
        _a.isPageWaitActive = false;
        for (const key of Object.keys(busyElements)) {
            busyElements[key].listener();
            delete busyElements[key];
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitAdapterService, deps: [{ token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitAdapterService }); }
}
_a = SkyWaitAdapterService;
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitAdapterService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i0.RendererFactory2 }] });

let nextId = 0;
class SkyWaitComponent {
    constructor() {
        this.ariaLabelStream = new BehaviorSubject('');
        this.ariaLiveText = '';
        this.screenReaderCompletedTextStream = new BehaviorSubject('');
        this.#id = `sky-wait-${++nextId}`;
        this.#ngUnsubscribe = new Subject();
        this.#adapterService = inject(SkyWaitAdapterService);
        this.#elRef = inject(ElementRef);
        this.#liveAnnouncer = inject(SkyLiveAnnouncerService);
        this.#resourceSvc = inject(SkyLibResourcesService);
    }
    /**
     * The ARIA label for the wait icon.
     * This sets the icon's `aria-label` attribute to provide a text equivalent for screen readers
     * [to support accessibility](https://developer.blackbaud.com/skyux/learn/accessibility) when an element or page loads and when users tab to a wait icon.
     * The default value varies based on whether the wait is for an element or a page and whether it is a blocking wait. For example, the default for a page-level blocking wait is "Page loading. Please wait."
     * For element-level waits, we recommend that consumers overwrite the default to describe the specific element.
     * "For more information, see the Design tab and the [WAI-ARIA `aria-label` definition](https://www.w3.org/TR/wai-aria/#aria-label).
     */
    set ariaLabel(value) {
        this.#customAriaLabel = value;
        this.#publishAriaLabel();
    }
    /**
     * When set to `true`, wait indication appears on the parent element of the `sky-wait` component.
     */
    set isWaiting(value) {
        if (!this.isFullPage) {
            if (value) {
                this.#adapterService.setWaitBounds(this.#elRef);
            }
            else {
                this.#adapterService.removeWaitBounds(this.#elRef);
            }
        }
        this.#adapterService.setBusyState(this.#elRef, !!this.isFullPage, !!value, !!this.isNonBlocking, this.#id);
        if (value) {
            this.#liveAnnouncer.announce(this.ariaLabelStream.getValue());
        }
        else if (this.#_isWaiting) {
            // NOTE: This should only happen if the wait was previously waiting and no longer is waiting.
            this.#liveAnnouncer.announce(this.screenReaderCompletedTextStream.getValue());
        }
        this.#_isWaiting = value;
    }
    get isWaiting() {
        return this.#_isWaiting;
    }
    /**
     * When set to `true`, wait indication appears on the page level instead of the
     * parent element level. We recommend that you use the `beginBlockingPageWait` or
     * `beginNonBlockingPageWait` functions of the `SkyWaitService` instead of setting this
     * on the component level.
     * @default false
     */
    set isFullPage(value) {
        /* istanbul ignore else: untestable */
        if (value) {
            this.#adapterService.removeWaitBounds(this.#elRef);
        }
        else if (this.isWaiting) {
            this.#adapterService.setWaitBounds(this.#elRef);
        }
        this.#_isFullPage = value;
        this.#publishAriaLabel();
        this.#publishScreenReaderCompletedText();
    }
    get isFullPage() {
        return this.#_isFullPage;
    }
    /**
     * When set to `true`, wait indication appears in the bottom left corner of the element
     * instead of hiding the entire parent element.
     * @default false
     */
    set isNonBlocking(value) {
        this.#_isNonBlocking = value;
        this.#publishAriaLabel();
    }
    get isNonBlocking() {
        return this.#_isNonBlocking;
    }
    /**
     * Screen reader text [to support accessibility](https://developer.blackbaud.com/skyux/learn/accessibility) when the wait toggles off.
     *  The default varies based on whether the wait is for an element or a page.
     * For example, the default for a page-level wait is "Page loading complete."
     * For element-level waits, we recommend that consumers overwrite the default to describe the specific element.
     * For more information, see the Design tab and the [WCAG documentation on status messages](https://www.w3.org/WAI/WCAG21/Understanding/status-messages.html).
     */
    set screenReaderCompletedText(value) {
        this.#customScreenReaderCompletedText = value;
        this.#publishScreenReaderCompletedText();
    }
    #customAriaLabel;
    #customScreenReaderCompletedText;
    #id;
    #ngUnsubscribe;
    #_isFullPage;
    #_isNonBlocking;
    #_isWaiting;
    #adapterService;
    #elRef;
    #liveAnnouncer;
    #resourceSvc;
    ngOnInit() {
        this.#publishAriaLabel();
        this.#publishScreenReaderCompletedText();
    }
    ngOnDestroy() {
        this.#ngUnsubscribe.next();
        this.#ngUnsubscribe.complete();
    }
    #publishAriaLabel() {
        if (this.#customAriaLabel) {
            this.ariaLabelStream.next(this.#customAriaLabel);
        }
        else {
            const type = this.isFullPage ? '_page' : '';
            const blocking = this.isNonBlocking ? '' : '_blocking';
            const key = `skyux_wait${type}${blocking}_aria_alt_text`;
            this.#resourceSvc
                .getString(key)
                .pipe(take$1(1), takeUntil(this.#ngUnsubscribe))
                .subscribe((value) => {
                this.ariaLabelStream.next(value);
            });
        }
    }
    #publishScreenReaderCompletedText() {
        if (this.#customScreenReaderCompletedText) {
            this.screenReaderCompletedTextStream.next(this.#customScreenReaderCompletedText);
        }
        else {
            const type = this.isFullPage ? '_page' : '';
            const key = `skyux_wait${type}_screen_reader_completed_text`;
            this.#resourceSvc
                .getString(key)
                .pipe(take$1(1), takeUntil(this.#ngUnsubscribe))
                .subscribe((value) => {
                this.screenReaderCompletedTextStream.next(value);
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyWaitComponent, isStandalone: true, selector: "sky-wait", inputs: { ariaLabel: "ariaLabel", isWaiting: "isWaiting", isFullPage: "isFullPage", isNonBlocking: "isNonBlocking", screenReaderCompletedText: "screenReaderCompletedText" }, providers: [SkyWaitAdapterService], ngImport: i0, template: "<div\n  class=\"sky-wait-container\"\n  [ngClass]=\"{\n    'sky-wait-full-page': isFullPage,\n    'sky-wait-non-blocking': isNonBlocking\n  }\"\n>\n  <div\n    *ngIf=\"isWaiting\"\n    class=\"sky-wait-mask\"\n    role=\"progressbar\"\n    [attr.aria-label]=\"ariaLabelStream | async\"\n    [ngClass]=\"{\n      'sky-wait-mask-loading-fixed': isFullPage,\n      'sky-wait-mask-loading-non-blocking': isNonBlocking,\n      'sky-wait-mask-loading-blocking': !isNonBlocking\n    }\"\n  >\n    <div class=\"sky-wait\">\n      <div class=\"sky-wait-double-bounce1\"></div>\n      <div class=\"sky-wait-double-bounce2\"></div>\n    </div>\n  </div>\n</div>\n", styles: [".sky-wait-mask-loading-blocking{margin:auto;position:absolute;inset:0;background-color:#ffffffb3;z-index:1000}.sky-wait-mask-loading-fixed{position:fixed}.sky-wait{width:50px;height:50px;margin-top:-25px;margin-left:-25px;position:absolute;top:50%;left:50%}.sky-wait-mask-loading-non-blocking{bottom:0}.sky-wait-mask-loading-non-blocking .sky-wait{inset:auto auto 0 0;margin-left:auto;margin-right:auto}.sky-wait-double-bounce1,.sky-wait-double-bounce2{width:100%;height:100%;border-radius:50%;background-color:#72bf44;opacity:.6;position:absolute;top:0;left:0;-webkit-animation:sk-bounce 2s infinite ease-in-out;animation:sk-bounce 2s infinite ease-in-out}.sky-wait-double-bounce2{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}.sky-wait-container.sky-wait-active{position:relative}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }, { kind: "ngmodule", type: SkyIndicatorsResourcesModule }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'sky-wait', providers: [SkyWaitAdapterService], imports: [CommonModule, SkyIndicatorsResourcesModule], template: "<div\n  class=\"sky-wait-container\"\n  [ngClass]=\"{\n    'sky-wait-full-page': isFullPage,\n    'sky-wait-non-blocking': isNonBlocking\n  }\"\n>\n  <div\n    *ngIf=\"isWaiting\"\n    class=\"sky-wait-mask\"\n    role=\"progressbar\"\n    [attr.aria-label]=\"ariaLabelStream | async\"\n    [ngClass]=\"{\n      'sky-wait-mask-loading-fixed': isFullPage,\n      'sky-wait-mask-loading-non-blocking': isNonBlocking,\n      'sky-wait-mask-loading-blocking': !isNonBlocking\n    }\"\n  >\n    <div class=\"sky-wait\">\n      <div class=\"sky-wait-double-bounce1\"></div>\n      <div class=\"sky-wait-double-bounce2\"></div>\n    </div>\n  </div>\n</div>\n", styles: [".sky-wait-mask-loading-blocking{margin:auto;position:absolute;inset:0;background-color:#ffffffb3;z-index:1000}.sky-wait-mask-loading-fixed{position:fixed}.sky-wait{width:50px;height:50px;margin-top:-25px;margin-left:-25px;position:absolute;top:50%;left:50%}.sky-wait-mask-loading-non-blocking{bottom:0}.sky-wait-mask-loading-non-blocking .sky-wait{inset:auto auto 0 0;margin-left:auto;margin-right:auto}.sky-wait-double-bounce1,.sky-wait-double-bounce2{width:100%;height:100%;border-radius:50%;background-color:#72bf44;opacity:.6;position:absolute;top:0;left:0;-webkit-animation:sk-bounce 2s infinite ease-in-out;animation:sk-bounce 2s infinite ease-in-out}.sky-wait-double-bounce2{-webkit-animation-delay:-1s;animation-delay:-1s}@-webkit-keyframes sk-bounce{0%,to{-webkit-transform:scale(0)}50%{-webkit-transform:scale(1)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}.sky-wait-container.sky-wait-active{position:relative}\n"] }]
        }], propDecorators: { ariaLabel: [{
                type: Input
            }], isWaiting: [{
                type: Input
            }], isFullPage: [{
                type: Input
            }], isNonBlocking: [{
                type: Input
            }], screenReaderCompletedText: [{
                type: Input
            }] } });

class SkyWaitModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitModule, imports: [SkyWaitComponent], exports: [SkyWaitComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitModule, imports: [SkyWaitComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [SkyWaitComponent],
                    exports: [SkyWaitComponent],
                }]
        }] });

/**
 * @internal
 */
class SkyWaitPageComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitPageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: SkyWaitPageComponent, isStandalone: true, selector: "sky-wait-page", inputs: { hasBlockingWait: "hasBlockingWait", hasNonBlockingWait: "hasNonBlockingWait" }, ngImport: i0, template: "<div class=\"sky-wait-page\">\n  <sky-wait\n    data-sky-id=\"page-wait-non-blocking\"\n    [isFullPage]=\"true\"\n    [isNonBlocking]=\"true\"\n    [isWaiting]=\"hasNonBlockingWait\"\n  >\n  </sky-wait>\n  <sky-wait\n    data-sky-id=\"page-wait-blocking\"\n    [isFullPage]=\"true\"\n    [isWaiting]=\"hasBlockingWait\"\n  >\n  </sky-wait>\n</div>\n", styles: [".sky-wait-page ::ng-deep .sky-wait-mask-loading-fixed{z-index:2000}\n"], dependencies: [{ kind: "component", type: SkyWaitComponent, selector: "sky-wait", inputs: ["ariaLabel", "isWaiting", "isFullPage", "isNonBlocking", "screenReaderCompletedText"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitPageComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'sky-wait-page', imports: [SkyWaitComponent], template: "<div class=\"sky-wait-page\">\n  <sky-wait\n    data-sky-id=\"page-wait-non-blocking\"\n    [isFullPage]=\"true\"\n    [isNonBlocking]=\"true\"\n    [isWaiting]=\"hasNonBlockingWait\"\n  >\n  </sky-wait>\n  <sky-wait\n    data-sky-id=\"page-wait-blocking\"\n    [isFullPage]=\"true\"\n    [isWaiting]=\"hasBlockingWait\"\n  >\n  </sky-wait>\n</div>\n", styles: [".sky-wait-page ::ng-deep .sky-wait-mask-loading-fixed{z-index:2000}\n"] }]
        }], propDecorators: { hasBlockingWait: [{
                type: Input
            }], hasNonBlockingWait: [{
                type: Input
            }] } });

let waitComponent;
let waitComponentRef;
let pageWaitBlockingCount = 0;
let pageWaitNonBlockingCount = 0;
class SkyWaitService {
    #environmentInjector = inject(EnvironmentInjector);
    #windowSvc = inject(SkyAppWindowRef);
    #dynamicComponentService = inject(SkyDynamicComponentService);
    /**
     * Starts a blocking page wait on the page.
     */
    beginBlockingPageWait() {
        this.#beginPageWait(true);
    }
    /**
     * Starts a non-blocking page wait on the page.
     */
    beginNonBlockingPageWait() {
        this.#beginPageWait(false);
    }
    /**
     * Ends a blocking page wait on the page. Blocking page wait indication
     * is removed when all running blocking page waits are ended.
     */
    endBlockingPageWait() {
        this.#endPageWait(true);
    }
    /**
     * Ends a non-blocking page wait on the page. Non-blocking page wait indication
     * is removed when all running non-blocking page waits are ended.
     */
    endNonBlockingPageWait() {
        this.#endPageWait(false);
    }
    /**
     * Clears all blocking and non-blocking page waits on the page.
     */
    clearAllPageWaits() {
        this.#clearPageWait(true);
        this.#clearPageWait(false);
    }
    /**
     * @internal
     */
    dispose() {
        if (waitComponent) {
            waitComponent = undefined;
            pageWaitBlockingCount = 0;
            pageWaitNonBlockingCount = 0;
            this.#dynamicComponentService.removeComponent(waitComponentRef);
        }
    }
    /**
     * Launches a page wait and automatically stops when the specific asynchronous event completes.
     */
    blockingWrap(observable) {
        return defer(() => {
            this.beginBlockingPageWait();
            return observable.pipe(finalize(() => this.endBlockingPageWait()));
        });
    }
    /**
     * Launches a non-blocking page wait and automatically stops when the specific
     * asynchronous event completes.
     */
    nonBlockingWrap(observable) {
        return defer(() => {
            this.beginNonBlockingPageWait();
            return observable.pipe(finalize(() => this.endNonBlockingPageWait()));
        });
    }
    #setWaitComponentProperties(isBlocking) {
        if (waitComponent) {
            if (isBlocking) {
                waitComponent.hasBlockingWait = true;
                pageWaitBlockingCount++;
            }
            else {
                waitComponent.hasNonBlockingWait = true;
                pageWaitNonBlockingCount++;
            }
        }
    }
    #beginPageWait(isBlocking) {
        if (!waitComponent) {
            /*
                Dynamic component creation needs to be done in a timeout to prevent ApplicationRef from
                crashing when wait service is called in Angular lifecycle functions.
            */
            this.#windowSvc.nativeWindow.setTimeout(() => {
                // Ensuring here that we recheck this after the setTimeout is over so that we don't clash
                // with any other waits that are created.
                if (!waitComponent) {
                    waitComponentRef = this.#dynamicComponentService.createComponent(SkyWaitPageComponent, {
                        environmentInjector: this.#environmentInjector,
                    });
                    waitComponent = waitComponentRef.instance;
                }
                this.#setWaitComponentProperties(isBlocking);
            });
        }
        else {
            this.#setWaitComponentProperties(isBlocking);
        }
    }
    #endPageWait(isBlocking) {
        /*
            Needs to yield so that wait creation can finish
            before it is dismissed in the event of a race.
        */
        this.#windowSvc.nativeWindow.setTimeout(() => {
            if (waitComponent) {
                if (isBlocking) {
                    if (pageWaitBlockingCount > 0) {
                        pageWaitBlockingCount--;
                    }
                    if (pageWaitBlockingCount < 1) {
                        waitComponent.hasBlockingWait = false;
                    }
                }
                else {
                    if (pageWaitNonBlockingCount > 0) {
                        pageWaitNonBlockingCount--;
                    }
                    if (pageWaitNonBlockingCount < 1) {
                        waitComponent.hasNonBlockingWait = false;
                    }
                }
            }
        });
    }
    #clearPageWait(isBlocking) {
        if (waitComponent) {
            if (isBlocking) {
                pageWaitBlockingCount = 0;
                waitComponent.hasBlockingWait = false;
            }
            else {
                pageWaitNonBlockingCount = 0;
                waitComponent.hasNonBlockingWait = false;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SkyWaitService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SkyAlertModule, SkyChevronModule, SkyExpansionIndicatorModule, SkyHelpInlineModule, SkyIllustrationModule, SkyIllustrationResolverService, SkyKeyInfoModule, SkyLabelModule, SkyStatusIndicatorModule, SkyTextHighlightDirective, SkyTextHighlightModule, SkyTokensMessageType, SkyTokensModule, SkyWaitModule, SkyWaitService, SkyAlertComponent as λ1, SkyStatusIndicatorComponent as λ10, SkyTextHighlightDirective as λ11, SkyTokenComponent as λ12, SkyTokensComponent as λ13, SkyWaitComponent as λ14, SkyExpansionIndicatorComponent as λ15, SkyIllustrationComponent as λ16, SkyChevronComponent as λ2, SkyHelpInlineComponent as λ3, SkyKeyInfoLabelComponent as λ6, SkyKeyInfoValueComponent as λ7, SkyKeyInfoComponent as λ8, SkyLabelComponent as λ9 };
